import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { useCallback, useEffect, useMemo, useState, useRef } from 'react'
// customerOptions: one-shot load; Autocomplete filters locally (same as Role Autocomplete)
import { useSnackbar } from 'notistack'
import { Form, FormikProvider, useFormik } from 'formik'
import {
  Box,
  Card,
  Grid,
  Stack,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Dialog,
  DialogTitle,
  Tooltip,
  Tabs,
  Tab,
  Backdrop,
  useMediaQuery,
  Paper,
  Divider,
  CircularProgress,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { LoadingButton } from '@material-ui/lab'
import LoadingScreen from 'src/components/LoadingScreen'
import Autocomplete, { createFilterOptions } from '@material-ui/core/Autocomplete'
import { BOOKINGS_DATA } from './MayuraDatas'
import Scrollbar from 'src/components/Scrollbar'
import { debounce } from 'lodash'
import useAuth from 'src/hooks/useAuth'
import MayuraReceiverAddEditForm from './MayuraReceiverAddEditForm'
import MayuraCustomerAddEditForm from './MayuraCustomerAddEditForm'
import { Close, ArrowBack } from '@material-ui/icons'
import { REST_API } from 'src/constants/DefaultValues'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import ThreeWheelerImg from 'src/images/three-image.png'
import { useJsApiLoader, Autocomplete as GoogleAutocomplete } from '@react-google-maps/api'
import { GOOGLE_MAPS_API_KEY } from 'src/DefaultValues'
import {
  isLocalStyleService,
  isOutstationService,
  isPassengerService,
  isPassengerUser,
  shouldUsePassengerMobileFlow,
  SERVICE_TYPE,
} from 'src/utils/serviceTypes'

const GOOGLE_MAPS_LIBRARIES = ['places'];

const DESTINATION_OPTIONS = Array.from(
  new Map(
    BOOKINGS_DATA.filter((c) => c.destination && c.destination.id).map((c) => [
      c.destination.id,
      c.destination,
    ]),
  ).values(),
)

const SENDER_OPTIONS = Array.from(
  new Map(
    BOOKINGS_DATA.filter((c) => c.sender && c.sender.id).map((c) => [
      c.sender.id,
      c.sender,
    ]),
  ).values(),
)

const RECEIVER_OPTIONS = Array.from(
  new Map(
    BOOKINGS_DATA.filter((c) => c.receiver && c.receiver.id).map((c) => [
      c.receiver.id,
      c.receiver,
    ]),
  ).values(),
)

const TYPE_OPTIONS = Array.from(
  new Map(
    BOOKINGS_DATA.flatMap((c) => c.items || [])
      .filter((item) => item.type && item.type.id)
      .map((item) => [item.type.id, item.type]),
  ).values(),
)
// const packageStatusOptions = [
//   { id: 0, name: 'Delivered' },
//   { id: 1, name: 'In Transit' },
//   { id: 2, name: 'Out for Delivery' },
//   { id: 3, name: 'Cancelled' },
// ];

const modeOfDeliveryOptions = [
  { id: 1, name: 'Door Delivery' },
  { id: 2, name: 'Godown Delivery' },
]

const paymentStatusOptions = [
  { id: 1, name: 'To Pay' },
  { id: 2, name: 'Paid' },
]
MayuraBookingAddEditForm.propTypes = {
  isEdit: PropTypes.bool,
  totalBookings: PropTypes.number,
  currentUser: PropTypes.object,
  onClose: PropTypes.func,
  setSavedUser: PropTypes.func,
}

export default function MayuraBookingAddEditForm({
  isEdit,
  nextBookingId,
  currentUser,
  onClose,
  setSavedUser,
  isApprovalMode,
  branchList,
  productTypes,
  contentTypes,
  customers,
  userList,
  totalBookings,
  fetchBookings,
  fetchBranches,
}) {
  console.log('productTypes+++++++++++++', currentUser)
  console.log('productTypes//////////', productTypes)
  console.log('productTypes+++++++++++++', contentTypes)
  const { enqueueSnackbar } = useSnackbar()
  const { user } = useAuth()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  console.log('productTypes+++++++++++++1', user)
  const formatDate = (date) => date.toISOString().split('T')[0]
  const [openAddReceiverDialog, setOpenAddReceiverDialog] = useState(false)
  const [openAddSenderDialog, setOpenAddSenderDialog] = useState(false)
  const [additionalSenders, setAdditionalSenders] = useState([])
  const [loadingVehicles, setLoadingVehicles] = useState(false)
  const [vehiclesOptions, setVehiclesOptions] = useState([])
  const [driversOptions, setDriversOptions] = useState([])
  const [loadingDrivers, setLoadingDrivers] = useState(false)
  const [loading, setLoading] = useState(false)
  const [tripList, setTripList] = useState([])
  const [loadingGodownDestination, setLoadingGodownDestination] = useState(false)
  const [godownDestinationList, setGodownDestinationList] = useState([])
  const [userDetails, setUserDetails] = useState(null)
  const [loadingUserDetails, setLoadingUserDetails] = useState(false)
  const [branchBookingCount, setBranchBookingCount] = useState(null)
  const [customerBookingCount, setCustomerBookingCount] = useState(null)
  // Start loading on create so passenger auto-submit waits for a real ID (not BOOK001)
  const [loadingBookingId, setLoadingBookingId] = useState(!isEdit)
  const [outstationReceivers, setOutstationReceivers] = useState([])
  const [customerOptions, setCustomerOptions] = useState(() =>
    Array.isArray(customers) ? customers : [],
  )
  const [senderInputValue, setSenderInputValue] = useState('')
  const [receiverInputValue, setReceiverInputValue] = useState('')
  const location = useLocation()
  const navigate = useNavigate()
  const [localServiceType, setLocalServiceType] = useState(
    currentUser?.service_type || location.state?.service_type || 2,
  )

  const getSenderOptionLabel = useCallback((option) => {
    if (!option) return ''
    if (typeof option === 'string') return option
    if (option.id === 'add-sender') return 'Add Sender'
    const name = `${option.first_name || option.user_name || ''} ${option.last_name || ''}`.trim()
    return `${name}${option.address ? ` (${option.address})` : ''}`.trim() || option.address || ''
  }, [])

  const getReceiverOptionLabel = useCallback((option) => {
    if (!option) return ''
    if (typeof option === 'string') return option
    if (option.id === 'add-receiver') return 'Add Receiver'
    return `${option.first_name || ''} ${option.last_name || ''}`.trim() || option.address || ''
  }, [])

  // Explicit local filter (Role-style). Bypass MUI pristine blank-input quirk.
  const filterSenderOptions = useMemo(
    () =>
      createFilterOptions({
        ignoreCase: true,
        matchFrom: 'any',
        stringify: (option) => {
          if (!option || option.id === 'add-sender') return 'Add Sender'
          return [
            option.first_name,
            option.last_name,
            option.user_name,
            option.address,
            option.phone_number,
          ]
            .filter(Boolean)
            .join(' ')
        },
      }),
    [],
  )

  const filterReceiverOptions = useMemo(
    () =>
      createFilterOptions({
        ignoreCase: true,
        matchFrom: 'any',
        stringify: (option) => {
          if (!option || option.id === 'add-receiver') return 'Add Receiver'
          return [
            option.first_name,
            option.last_name,
            option.user_name,
            option.address,
            option.phone_number,
          ]
            .filter(Boolean)
            .join(' ')
        },
      }),
    [],
  )

  const getCustomerIncludeIds = useCallback(() => {
    const ids = []
    if (currentUser?.sender_id) ids.push(currentUser.sender_id)
    if (currentUser?.receiver_id) ids.push(currentUser.receiver_id)
    return ids
  }, [currentUser?.sender_id, currentUser?.receiver_id])

  // One-shot load (same pattern as Role Autocomplete) — client filters locally
  const fetchCustomersForBooking = useCallback(
    async (customerType = null) => {
      try {
        const res = await axios.post(
          `${REST_API}customers/search-customers-for-booking`,
          {
            search: '',
            limit: 10000,
            include_ids: getCustomerIncludeIds(),
            include_user_id: Number(user?.user_type) === 2 ? user?.id : null,
            customer_type: customerType,
          },
        )
        setCustomerOptions(res.data.status === 1 ? res.data.data || [] : [])
      } catch (err) {
        console.error('Error fetching customers for booking:', err)
      }
    },
    [getCustomerIncludeIds, user?.id, user?.user_type],
  )

  useEffect(() => {
    fetchCustomersForBooking()
  }, [fetchCustomersForBooking])
  // Passenger (service_type 3) edit form only — labels/fields below must not affect add/local/outstation
  const isPassengerBookingEdit = isEdit && isPassengerService(localServiceType)

  const [openLocalConfirm, setOpenLocalConfirm] = useState(false);
  const [pendingPayload, setPendingPayload] = useState(null);
  const [pendingHelpers, setPendingHelpers] = useState(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const isSubmittingRef = useRef(false);
  const [googleAutocomplete, setGoogleAutocomplete] = useState(null)

  const handlePassengerReviewBack = () => {
    if (isConfirmLoading) return;
    setOpenLocalConfirm(false);
    passengerDirectConfirmStartedRef.current = false;
    if (typeof onClose === 'function') {
      onClose();
    }
    navigate(PATH_DASHBOARD.general.selectVehicle, {
      state: {
        ...location.state,
        service_type: localServiceType || 3,
        restorePassengerRide: true,
      },
    });
  };

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  })

  if (loadError) {
    console.error("Google Maps Load Error (Form):", loadError);
  }
  console.log('localServiceType++++++++++++++++', localServiceType)

  // const [selectedPackageStatus, setSelectedPackageStatus] = useState(
  //   currentUser?.package_status !== undefined
  //     ? packageStatusOptions.find((opt) => opt.id === currentUser.package_status)
  //     : null
  // )

  const [selectedModeOfDelivery, setSelectedModeOfDelivery] = useState(
    currentUser?.delivery_status !== undefined
      ? modeOfDeliveryOptions.find(
        (opt) => opt.id === currentUser.delivery_status,
      )
      : null,
  )

  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(
    currentUser?.payment_status !== undefined
      ? paymentStatusOptions.find(
        (opt) => opt.id === currentUser.payment_status,
      )
      : null,
  )
  // const handlePackageStatusChange = (event, newValue) => {
  //   setSelectedPackageStatus(newValue);
  // };

  const handleModeOfDeliveryChange = (event, newValue) => {
    setSelectedModeOfDelivery(newValue)
  }

  const handlePaymentStatusChange = (event, newValue) => {
    setSelectedPaymentStatus(newValue)
  }

  const derivedDestination = location.state?.derivedDestination
  const fetchDrivers = async () => {
    setLoadingDrivers(true)
    try {
      const res = await axios.post(`${REST_API}drivers/get-all-active-drivers`)
      setDriversOptions(res.data.status === 1 ? res.data.data : [])
    } catch (err) {
      console.error('Error fetching drivers:', err)
      setDriversOptions([])
    } finally {
      setLoadingDrivers(false)
    }
  }

  const fetchVehicles = async () => {
    setLoadingVehicles(true)
    try {
      const addedByCustomer =
        currentUser?.added_by_user_type === 2 || user?.user_type === 2

      const [truckRes, localRes] = await Promise.all([
        axios.post(`${REST_API}trucks/get-all-active-trucks`),
        axios.post(`${REST_API}bookings/get-local-vehicles`, {
          service_type: currentUser?.service_type || location.state?.service_type || localServiceType,
          // Old Passenger bookings use local_vehicles ids; include them when editing.
          include_legacy:
            Number(
              currentUser?.service_type ||
                location.state?.service_type ||
                localServiceType,
            ) === 3,
          customerId: user?.user_type === 2 ? user.id : currentUser?.added_by,
        })
      ])

      const trucks = truckRes.data?.status === 1 ? truckRes.data.data : []
      const locals = localRes.data?.status === 1 ? localRes.data.data : []

      const formattedLocals = locals.map(v => ({
        ...v,
        isLocal: true
      }))

      setVehiclesOptions([...trucks, ...formattedLocals])
    } catch (error) {
      console.error('Error fetching vehicles:', error)
      setVehiclesOptions([])
    } finally {
      setLoadingVehicles(false)
    }
  }
  // const fetchTrips = async () => {
  //   setLoading(true)
  //   try {
  //     const res = await axios.post(`${REST_API}trips/get-all-trips`)
  //     setTripList(res.data.status === 1 ? res.data.data : [])
  //   } catch (error) {
  //     console.error('Error fetching roles:', error)
  //     setTripList([])
  //   } finally {
  //     setLoading(false)
  //   }
  // }
  const fetchGodownDestination = async () => {
    setLoadingGodownDestination(true);
    try {
      const res = await axios.post(`${REST_API}bookings/get-godown-destination`);

      if (res.data?.status === 1 && Array.isArray(res.data.data)) {
        setGodownDestinationList(res.data.data);
      } else {
        setGodownDestinationList([]);
      }
    } catch (error) {
      console.error('Error fetching godown destinations:', error);
      setGodownDestinationList([]);
    } finally {
      setLoadingGodownDestination(false);
    }
  };

  // Fetch user details to get branch information
  const fetchUserDetails = async () => {
    if (user?.id) {
      setLoadingUserDetails(true);
      try {
        const res = await axios.post(`${REST_API}users/get-user-by-id`, { user_id: user.id });
        if (res.data.status === 1) {
          console.log('User details fetched:', res.data.data);
          setUserDetails(res.data.data);
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      } finally {
        setLoadingUserDetails(false);
      }
    } else {
      setLoadingUserDetails(false);
    }
  };

  // Fetch appropriate booking count based on user type
  const fetchBookingIdInfo = async () => {
    console.log('🔍 fetchBookingIdInfo called - user_type:', user?.user_type, 'user_id:', user?.id);
    if (isEdit) {
      setLoadingBookingId(false);
      return;
    }

    setLoadingBookingId(true);
    try {
      if (user?.user_type === 5 && user?.id) {
        const res = await axios.post(`${REST_API}bookings/get-branch-booking-count`, {
          user_id: user.id
        });
        if (res.data.status === 1) {
          setBranchBookingCount(res.data.data.count);
        }
      } else if (user?.user_type === 2 && user?.id) {
        // For customers, fetch global count to estimate next ID correctly
        const res = await axios.post(`${REST_API}bookings/get-total-bookings-with-count`, {});
        if (res.data.status === 1) {
          setCustomerBookingCount(res.data.total_bookings);
        }
      } else {
        // For other users, fetch global count
        const res = await axios.post(`${REST_API}bookings/get-total-bookings-with-count`, {});
        if (res.data.status === 1) {
          setCustomerBookingCount(res.data.total_bookings);
        }
      }
    } catch (err) {
      console.error('Error fetching booking count information:', err);
    } finally {
      setLoadingBookingId(false);
    }
  };

  // Generate booking ID based on user type and branch code
  const generateBookingId = (passedCount = null) => {
    console.log('generateBookingId called - user:', user);
    console.log('generateBookingId called - userDetails:', userDetails);
    console.log('generateBookingId called - nextBookingId:', nextBookingId);
    console.log('generateBookingId called - branchList:', branchList);

    // Resolve which branch booking count to use
    const finalBranchCount = passedCount !== null ? passedCount : branchBookingCount;
    console.log('generateBookingId called - finalBranchCount:', finalBranchCount);

    // For branch users (user_type = 5), look up branch code from branchList
    if (user?.user_type === 5) {
      // Find the branch where user_id matches the current user's ID
      const userBranch = branchList?.find(branch => branch.user_id === user?.id);
      console.log('Found user branch:', userBranch);

      if (userBranch?.branch_code) {
        // For branch users, use branch-specific booking count + 1
        const branchNextNumber = finalBranchCount !== null ? finalBranchCount + 1 : 1;
        const bookingNumber = branchNextNumber.toString().padStart(3, '0');
        const generatedId = `${userBranch.branch_code}${bookingNumber}`;
        console.log('Generated branch booking ID:', generatedId, 'for branch:', userBranch.branch_name, 'count:', branchNextNumber);
        return generatedId;
      } else {
        console.log('No branch code found for user, falling back to regular format');
      }
    }

    // For other users (admin/customer/passenger) or if branch code not found
    const fromCount = customerBookingCount !== null ? customerBookingCount + 1 : 0;
    const fromNext = Number(nextBookingId) || 1;
    const baseId = Math.max(fromCount, fromNext);
    const generatedId = (isEdit && currentUser?.id)
      ? `BOOK${currentUser.id.toString().padStart(3, '0')}`
      : `BOOK${baseId.toString().padStart(3, '0')}`;
    console.log('Generated regular booking ID:', generatedId);
    return generatedId;
  };

  useEffect(() => {
    fetchVehicles()
    fetchDrivers()
    fetchGodownDestination()
    fetchUserDetails()
    fetchBookingIdInfo()
  }, [user, isEdit])

  const onGoogleLoad = (autocompleteInstance) => {
    setGoogleAutocomplete(autocompleteInstance)
  }

  const onGooglePlaceChanged = () => {
    if (googleAutocomplete !== null) {
      const place = googleAutocomplete.getPlace()
      if (place && place.geometry) {
        const addressComponents = place.address_components
        const getComponent = (type) =>
          addressComponents.find((c) => c.types.includes(type))?.long_name || ''

        const newReceiver = {
          address: place.formatted_address,
          city: getComponent('locality'),
          state: getComponent('administrative_area_level_1'),
          postal_code: getComponent('postal_code'),
          landmark:
            getComponent('sublocality') ||
            getComponent('neighborhood') ||
            getComponent('route'),
          first_name: 'New',
          last_name: 'Location',
          isGooglePlace: true,
        }
        setFieldValue('receiver', newReceiver)
      }
    }
  }


  // const BookingSchema = Yup.object().shape({
  //   // sender: Yup.mixed().when('$userType', {
  //   //   is: 2,
  //   //   then: Yup.string().required('Sender is required'),
  //   //   otherwise: Yup.object().nullable().required('Sender is required'),
  //   // }),
  //  sender: Yup.object()
  // .nullable()
  // .shape({
  //   id: Yup.number().required(),
  //   first_name: Yup.string(),
  //   last_name: Yup.string(),
  // })
  // .required('Sender is required'),

  //   // destination: Yup.object().nullable().required('Destination is required'),
  //   destination: Yup.mixed().when('$localServiceType ', {
  //     is: 1,
  //     then: Yup.object().nullable().required('Destination is required'),
  //     otherwise: Yup.mixed().nullable(),
  //   }),
  //   trip: Yup.mixed().when('$localServiceType ', {
  //     is: 2,
  //     then: Yup.object().nullable().required('Trip is required'),
  //     otherwise: Yup.mixed().nullable(),
  //   }),
  //   receiver: Yup.object().nullable().required('Receiver is required'),
  //   // comments: Yup.string()
  //   //   .matches(/^[a-zA-Z\s]{2,30}$/, 'Only letters and spaces allowed')
  //   //   .nullable(),
  //   comments: Yup.string()
  // .max(200, 'Max 200 characters allowed')
  // .nullable(),
  //   items: Yup.array()
  //     .of(
  //       Yup.object().shape({
  //         product_type: Yup.object().nullable().required('Type is required'),
  //         item: Yup.object().nullable().required('Item is required'),
  //         // item: Yup.string().required('Item is required'),
  //         qty: Yup.number()
  //           .typeError('Qty must be a number')
  //           .required('Qty is required')
  //           .min(0, 'Qty must be a positive number'),
  //         weight: Yup.number()
  //           .typeError('Weight must be a number')
  //           .required('Weight is required')
  //           .min(0, 'Weight must be a positive number'),
  //         price: Yup.number()
  //           .typeError('Price must be a number')
  //           .required('Price is required'),
  //       }),
  //     )
  //     .min(1, 'At least one item is required'),

  //   freight: Yup.number()
  //     .typeError('Freight must be a number')
  //     .nullable()
  //     .min(0, 'Freight must be a positive number')
  //     .when([], {
  //       is: () => user?.user_type !== 2,
  //       then: (schema) => schema.required('Freight is required'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),

  //   surcharge: Yup.number()
  //     .typeError('Surcharge must be a number')
  //     .nullable()
  //     .min(0, 'Surcharge must be a positive number')
  //     .when([], {
  //       is: () => user?.user_type !== 2,
  //       then: (schema) => schema.required('Surcharge is required'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),

  //   stationary: Yup.number()
  //     .typeError('Stationary must be a number')
  //     .nullable()
  //     .min(0, 'Stationary must be a positive number')
  //     .when([], {
  //       is: () => user?.user_type !== 2,
  //       then: (schema) => schema.required('Stationary is required'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),

  //   handling: Yup.number()
  //     .typeError('Handling must be a number')
  //     .nullable()
  //     .min(0, 'Handling must be a positive number')
  //     .when([], {
  //       is: () => user?.user_type !== 2,
  //       then: (schema) => schema.required('Handling is required'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),

  //   demurrage: Yup.number()
  //     .typeError('Demurrage must be a number')
  //     .nullable()
  //     .min(0, 'Demurrage must be a positive number')
  //     .when([], {
  //       is: () => user?.user_type !== 2,
  //       then: (schema) => schema.required('Demurrage is required'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),

  //   door_collect: Yup.number()
  //     .typeError('Door Collect must be a number')
  //     .nullable()
  //     .min(0, 'Door Collect must be a positive number')
  //     .when([], {
  //       is: () => user?.user_type !== 2,
  //       then: (schema) => schema.required('Door Collect is required'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),

  //   door_delivery: Yup.number()
  //     .typeError('Door Delivery must be a number')
  //     .nullable()
  //     .min(0, 'Door Delivery must be a positive number')
  //     .when([], {
  //       is: () => user?.user_type !== 2,
  //       then: (schema) => schema.required('Door Delivery is required'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),

  //   insurance: Yup.number()
  //     .typeError('Insurance must be a number')
  //     .nullable()
  //     .min(0, 'Insurance must be a positive number')
  //     .when([], {
  //       is: () => user?.user_type !== 2,
  //       then: (schema) => schema.required('Insurance is required'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),

  //   total_charge: Yup.number()
  //     .typeError('Total Charge must be a number')
  //     .nullable(),

  //   subtotal: Yup.number().typeError('Subtotal must be a number').nullable(),

  //   tax: Yup.number().typeError('Tax must be a number').nullable(),

  //   total: Yup.number().typeError('Total must be a number').nullable(),
  // })
  const BookingSchema = (userType, localServiceType, editMode) =>
    Yup.object().shape({
      sender: Yup.object()
        .nullable()
        .required(editMode && isPassengerService(localServiceType) ? 'Passenger Name is required' : 'Sender is required'),
      passenger_name:
        editMode && isPassengerService(localServiceType)
          ? Yup.string().trim().required('Passenger Name is required')
          : Yup.mixed().nullable(),

      // destination:
      //   isLocalStyleService(localServiceType) && userType !== 5
      //     ? Yup.object().nullable().required('Destination is required')
      //     : Yup.mixed().nullable(),
      destination: Yup.mixed().nullable(),
      // trip:
      //   localServiceType === 2
      //     ? Yup.object().nullable().required('Trip is required')
      //     : Yup.mixed().nullable(),
      trip: Yup.mixed().nullable(),

      vehicle: (userType !== 5 && userType !== 2 && userType !== 7 && (isLocalStyleService(localServiceType) || userType !== 1))
        ? Yup.object().nullable().required('Vehicle is required')
        : Yup.mixed().nullable(),

      driver: Yup.mixed().nullable(),


      invoice_no:
        userType === 1 || userType === 5
          ? Yup.string()
            .trim()
            .required('Invoice No is required')
            .max(40, 'Max 40 characters')
            .matches(
              /^[A-Za-z0-9][A-Za-z0-9/_\-. ]*$/,
              'Only letters, numbers, /, -, _, . and spaces'
            )
          : Yup.string().nullable(),

      invoice_value:
        (userType === 1 || userType === 5) && isOutstationService(localServiceType)
          ? Yup.number()
            .transform((val, orig) => (orig === '' ? null : Number(orig)))
            .typeError('Invoice Value must be a number')
            .required('Invoice Value is required')
            .min(0, 'Invoice Value must be a positive amount')
            .test(
              'max-2dp',
              'At most 2 decimal places',
              (val) => val == null || Math.round(val * 100) === val * 100
            )
          : Yup.number().nullable(),


      delivery_status:
        editMode && isPassengerService(localServiceType)
          ? Yup.number().nullable()
          : Yup.number().nullable().required('Mode of Delivery is required'),
      payment_status: Yup.number().nullable().required('Payment Status is required'),

      // door_delivery_destination: Yup.string().when('delivery_status', {
      //   is: 1, // Door Delivery
      //   then: Yup.string().nullable().required('Door Delivery Destination is required'),
      //   otherwise: Yup.string().nullable()
      // }),
      godown_delivery_destination_id: Yup.number().when('delivery_status', {
        is: 2, // Godown Delivery
        then: Yup.number().nullable().required('Godown Destination is required'),
        otherwise: Yup.number().nullable()
      }),

      receiver: isLocalStyleService(localServiceType)
        ? Yup.mixed().nullable()
        : Yup.object().nullable().required('Receiver is required'),

      receiverAddress: isLocalStyleService(localServiceType)
        ? Yup.mixed().nullable()
        : Yup.object().nullable().required('Receiver address is required'),

      comments: Yup.string().max(200, 'Max 200 characters allowed').nullable(),
      sender_phone: isPassengerService(localServiceType)
        ? Yup.string().matches(/^[0-9]{10}$/, 'Phone number must be 10 digits').nullable()
        : isLocalStyleService(localServiceType)
          ? Yup.string()
            .required('Sender phone number is required')
            .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits and contain no letters')
          : Yup.string().matches(/^[0-9]{10}$/, 'Phone number must be 10 digits').nullable(),
      receiver_phone: isPassengerService(localServiceType)
        ? Yup.string().matches(/^[0-9]{10}$/, 'Phone number must be 10 digits').nullable()
        : isLocalStyleService(localServiceType)
          ? Yup.string()
            .required('Receiver phone number is required')
            .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits and contain no letters')
          : Yup.string().matches(/^[0-9]{10}$/, 'Phone number must be 10 digits').nullable(),

      receiver_name: isPassengerService(localServiceType)
        ? Yup.string().nullable()
        : isLocalStyleService(localServiceType)
          ? Yup.string().trim().required('Receiver name is required')
          : Yup.string().nullable(),

      items: isLocalStyleService(localServiceType)
        ? Yup.array().nullable()
        : Yup.array()
          .of(
            Yup.object().shape({
              product_type: Yup.object().nullable().required('Type is required'),
              item: Yup.object().nullable().required('Item is required'),
              qty: Yup.number()
                .typeError('Qty must be a number')
                .required('Qty is required')
                .min(0, 'Qty must be a positive number'),
              weight: Yup.number()
                .typeError('Weight must be a number')
                .required('Weight is required')
                .min(0, 'Weight must be a positive number'),
              // price: Yup.number()
              //   .typeError('Price must be a number')
              //   .required('Price is required'),
            })
          )
          .min(1, 'At least one item is required'),

      distance: Yup.number().nullable(),




      freight: (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
        ? Yup.number()
          .typeError('Freight must be a number')
          .required('Freight is required')
          .min(0)
        : Yup.number().nullable(),

      surcharge: (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
        ? Yup.number()
          .typeError('Surcharge must be a number')
          .required('Surcharge is required')
          .min(0)
        : Yup.number().nullable(),

      stationary: (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
        ? Yup.number()
          .typeError('Stationary must be a number')
          .required('Stationary is required')
          .min(0)
        : Yup.number().nullable(),

      handling: (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
        ? Yup.number()
          .typeError('Handling must be a number')
          .required('Handling is required')
          .min(0)
        : Yup.number().nullable(),

      demurrage: (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
        ? Yup.number()
          .typeError('Demurrage must be a number')
          .required('Demurrage is required')
          .min(0)
        : Yup.number().nullable(),

      door_collect: (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
        ? Yup.number()
          .typeError('Door Collect must be a number')
          .required('Door Collect is required')
          .min(0)
        : Yup.number().nullable(),

      door_delivery: (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
        ? Yup.number()
          .typeError('Door Delivery must be a number')
          .required('Door Delivery is required')
          .min(0)
        : Yup.number().nullable(),

      insurance: (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
        ? Yup.number()
          .typeError('Insurance must be a number')
          .required('Insurance is required')
          .min(0)
        : Yup.number().nullable(),

      total_charge:
        userType === 1 || userType === 5 || userType === 8
          ? Yup.number()
            .typeError('Total Charge must be a number')
            .required('Total Charge is required')
            .min(0)
          : Yup.number().nullable(),
      subtotal: Yup.number().nullable(),
      tax:
        (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
          ? Yup.number()
            .typeError('Tax must be a number')
            .required('Tax is required')
            .min(0)
          : Yup.number().nullable(),


      total:
        (userType === 1 || userType === 5 || userType === 8) && isOutstationService(localServiceType)
          ? Yup.number()
            .typeError('Total must be a number')
            .required('Total is required')
            .min(0)
          : Yup.number().nullable(),
    });


  console.log('currentUser=========1', user?.id)
  console.log('currentUser=========1', customerOptions)
  console.log(
    'currentUser=========',
    customerOptions.find((opt) => opt.user_id === user?.id),
  )
  // const initialDestination = branchList.find(
  //   (opt) => opt.id === currentUser?.branch_id,
  // )

  // const initialDestination =
  //   currentUser?.branch_id && Array.isArray(branchList)
  //     ? branchList.find((opt) => opt.id === currentUser.branch_id)
  //     : null
  const initialDestination =
    isLocalStyleService(localServiceType) && (derivedDestination || currentUser?.destination)
      ? (derivedDestination || currentUser.destination)
      : currentUser?.branch_id && Array.isArray(branchList)
        ? branchList.find((opt) => opt.id === currentUser.branch_id)
        : null

  const initialTrip =
    currentUser?.trip?.id && Array.isArray(tripList)
      ? tripList.find((opt) => opt.id === currentUser.trip.id) || null
      : currentUser?.trip_id && Array.isArray(tripList)
        ? tripList.find((opt) => opt.id === currentUser.trip_id) || null
        : null

  const initialSender = (() => {
    // Prefer the sender object from SelectVehicle / navigation (Passenger + Local)
    const fromNav = currentUser?.sender || location.state?.selectedSender || null
    let sender = fromNav?.id ? { ...fromNav } : null

    if (!sender && currentUser?.sender_id && Array.isArray(customerOptions)) {
      // Passenger edit uses passengers.id in sender_id — do not match against customers
      if (!(isEdit && isPassengerService(localServiceType))) {
        sender = customerOptions.find((opt) => opt.id === currentUser.sender_id) || null
      }
    }
    if (!sender && user?.user_type === 2) {
      sender = customerOptions.find((opt) => opt.user_id === user?.id) || null
    }
    // Universal fallback: if sender is still null on edit (e.g., newly added sender not yet in stale customers list)
    if (!sender && isEdit && currentUser?.sender_id) {
      const name = (currentUser.sender_name || '').trim()
      sender = {
        id: currentUser.sender_id,
        first_name: name,
        last_name: '',
        user_name: name,
        phone_number: currentUser.sender_phone || '',
        address: currentUser.sender_address || currentUser.current_address || '',
      }
    }

    // If coming from SelectVehiclePage with Current Location (localstatus=2/3),
    // inject the GPS coordinates captured there into the sender object
    const stateLocalstatus = currentUser?.localstatus || location.state?.localstatus;
    const lat = currentUser?.pickup_latitude || location.state?.current_latitude;
    const lng = currentUser?.pickup_longitude || location.state?.current_longitude;
    if (sender && (stateLocalstatus === 2 || stateLocalstatus === 3) && lat && lng) {
      sender = {
        ...sender,
        current_latitude: lat,
        current_longitude: lng,
      };
    }
    return sender;
  })();

  let initialReceiver = currentUser?.receiver
    ? currentUser.receiver
    : isLocalStyleService(localServiceType) && location.state?.selectedReceiver
      ? location.state.selectedReceiver
      : customerOptions.find((opt) => opt.id === currentUser?.receiver_id) || null

  // Universal fallback for receiver on edit when customers list is stale
  if (!initialReceiver && isEdit && currentUser?.receiver_id) {
    const name = (currentUser.receiver_name || currentUser.consignee || '').trim()
    initialReceiver = {
      id: currentUser.receiver_id,
      first_name: name,
      last_name: '',
      user_name: name,
      phone_number: currentUser.receiver_phone || '',
      address: currentUser.receiver_address || currentUser.destination_name || '',
    }
  }

  const initialVehicle = useMemo(() => {
    if (!currentUser?.vehicle_id || !vehiclesOptions.length) return null;
    return vehiclesOptions.find((v) =>
      v.id === currentUser.vehicle_id &&
      (isLocalStyleService(localServiceType) ? !!v.isLocal : !v.isLocal)
    ) || null;
  }, [currentUser?.vehicle_id, vehiclesOptions, localServiceType]);

  const initialDriver = currentUser?.driver_id
    ? driversOptions.find((d) => d.id === currentUser.driver_id) || {
      id: currentUser.driver_id,
      driver_name: currentUser.driver_name || 'Driver',
    }
    : null
  // const initialItems = currentUser?.items?.map((item) => ({
  //   product_type:
  //     productTypes.find((pt) => pt.id === item.product_type) || null,
  //   item: contentTypes.find((ct) => ct.id === item.item) || null,
  //   // item: item.item,
  //   qty: item.qty,
  //   weight: item.weight,
  //   price: item.price ?? '',
  // })) || [
  //   {
  //     product_type: null,
  //     item: '',
  //     qty: '',
  //     weight: '',
  //     price: '',
  //   },
  // ]

  const initialItems =
    currentUser?.items?.length > 0
      ? currentUser.items.map((item) => {
        const productType =
          productTypes.find(
            (pt) => pt.id === (item.product_type?.id || item.product_type),
          ) ||
          item.product_type ||
          null

        const contentType =
          contentTypes.find((ct) => ct.id === (item.item?.id || item.item)) ||
          item.item ||
          null

        return {
          product_type: productType,
          item: contentType,
          qty: item.qty ?? '',
          weight: item.weight ?? '',
          charge_weight: item.charge_weight ?? '',
          // price: item.price ?? '',
        }
      })
      : [
        {
          product_type: null,
          item: null,
          qty: '',
          weight: '',
          charge_weight: '',
          // price: '',
        },
      ]



  const validationSchema = BookingSchema(user?.user_type, localServiceType, isEdit);
  console.log('📋 Validation schema created for user_type:', user?.user_type, 'localServiceType:', localServiceType);

  // Helper: calculate distance between two points/addresses using Google Distance Matrix
  const calculateDistanceAsync = (origin, destination) => {
    return new Promise((resolve) => {
      if (!window.google?.maps?.DistanceMatrixService) {
        resolve(null);
        return;
      }
      const service = new window.google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        { origins: [origin], destinations: [destination], travelMode: window.google.maps.TravelMode.DRIVING },
        (response, status) => {
          if (status === 'OK' && response.rows[0].elements[0].status === 'OK') {
            const km = (response.rows[0].elements[0].distance.value / 1000).toFixed(2);
            resolve(km);
          } else {
            console.warn('Distance Matrix failed:', status);
            resolve(null);
          }
        }
      );
    });
  };

  const formik = useFormik({
    validationSchema: validationSchema,
    enableReinitialize: true,
    initialValues: {
      bookingNo: isEdit
        ? (currentUser?.bookingnewid || `BOOK${String(currentUser?.id || '').padStart(3, '0')}`)
        : generateBookingId(),

      // destination:
      //   localServiceType  === 1
      //     ? currentUser?.branch_id
      //       ? initialDestination
      //       : null
      //     : null,
      destination: isLocalStyleService(localServiceType) ? initialDestination : null,

      // trip: localServiceType  === 2 ? initialTrip || null : null,
      trip:
        user?.user_type === 1 || localServiceType === 2
          ? initialTrip || null
          : null,

      sender: initialSender || null,
      passenger_name: isPassengerBookingEdit
        ? (
            (initialSender
              ? `${initialSender.first_name || initialSender.user_name || ''} ${initialSender.last_name || ''}`.trim()
              : '') || currentUser?.sender_name || ''
          )
        : '',
      receiver: initialReceiver || null,
      receiverAddress: (() => {
        if (!initialReceiver) return null
        const addrs = initialReceiver.addresses || []
        if (currentUser?.receiver_address_id) {
          const match = addrs.find((a) => String(a.id) === String(currentUser.receiver_address_id))
          if (match) return match
        }
        if (addrs.length === 1) return addrs[0]
        if (currentUser?.receiver_address && !addrs.length) {
          return {
            id: currentUser.receiver_address_id || null,
            label: 'Address 1',
            address: currentUser.receiver_address,
            landmark: '',
            city: '',
            legacy: true,
          }
        }
        return null
      })(),
      door_delivery_destination:
        currentUser?.door_delivery_destination ||
        (isLocalStyleService(localServiceType)
          ? derivedDestination?.branch_name ||
            currentUser?.destination?.branch_name ||
            location.state?.derivedDestination?.branch_name ||
            ''
          : ''),
      godown_delivery_destination_id:
        currentUser?.godown_delivery_destination_id || null,
      derivedDestination:
        isLocalStyleService(localServiceType) && derivedDestination
          ? derivedDestination.branch_name
          : '',
      invoice_no: currentUser?.invoice_no || '',
      invoice_value: currentUser?.invoice_value || '',
      vehicle: initialVehicle || null,
      driver: initialDriver || null,
      service_type: currentUser?.service_type || localServiceType,
      delivery_status: currentUser?.delivery_status ?? (isLocalStyleService(localServiceType) ? 1 : null),
      payment_status: currentUser?.payment_status ?? 1,
      sender_phone: currentUser?.sender_phone || initialSender?.phone_number || '',
      receiver_phone:
        currentUser?.receiver_phone ||
        initialReceiver?.phone_number ||
        location.state?.receiver_phone ||
        '',
      receiver_name:
        currentUser?.receiver_name ||
        currentUser?.consignee ||
        location.state?.receiver_name ||
        '',
      comments: currentUser?.comments || '',
      items: initialItems || [
        {
          product_type: null,
          item: '',
          qty: '',
          weight: '',
          // price: '',
        },
      ],
      freight: currentUser?.freight || '',
      surcharge: currentUser?.surcharge || '',
      stationary: currentUser?.stationary || '',
      handling: currentUser?.handling || '',
      demurrage: currentUser?.demurrage || '',
      door_collect: currentUser?.door_collect || '',
      door_delivery: currentUser?.door_delivery || '',
      insurance: currentUser?.insurance || '',
      total_charge: currentUser?.total_charge || currentUser?.local_charge || '',
      subtotal: currentUser?.sub_total || '',
      tax: currentUser?.tax || '',
      total: currentUser?.total || currentUser?.local_charge || '',
      distance: currentUser?.distance || '',
      localstatus: currentUser?.localstatus || location.state?.localstatus || 1,
      pickup_latitude: currentUser?.pickup_latitude || location.state?.current_latitude || '',
      pickup_longitude: currentUser?.pickup_longitude || location.state?.current_longitude || '',
      pickup_address: currentUser?.pickup_address || location.state?.sender_search_location || '',
      sender_search_location: currentUser?.sender_search_location || location.state?.sender_search_location || '',
      // excludeTax: currentUser?.exclude_tax === 1 ? true : false || false,
    },
    validationSchema: BookingSchema(user?.user_type, localServiceType, isEdit),
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        console.log('🚀 Starting booking submission process...')
        console.log('📝 Form values:', values)
        console.log('✏️ Is edit mode:', isEdit)
        console.log('👤 Current user:', user)
        console.log('🔍 User type:', user?.user_type, 'User name:', user?.name)
        console.log('📊 Form validation errors:', errors)
        console.log('✅ Form is valid:', Object.keys(errors).length === 0)
        // Prepare notification targets for backend
        const notificationTargets = []

        // Add sender (if different from current user)
        if (values.sender?.id && values.sender.id !== user?.id) {
          notificationTargets.push({
            user_id: values.sender.id,
            user_type: values.sender.user_type || 2
          })
        }

        // Add receiver (if different from current user and sender)
        if (values.receiver?.id &&
          values.receiver.id !== user?.id &&
          values.receiver.id !== values.sender?.id) {
          notificationTargets.push({
            user_id: values.receiver.id,
            user_type: values.receiver.user_type || 2
          })
        }

        // Add admin users (user_type = 1) - but not the current user if they're already admin
        if (user?.user_type !== 1) {
          const adminUsers = userList.filter(u => u.user_type === 1)
          adminUsers.forEach(admin => {
            if (admin.id !== user?.id) {
              notificationTargets.push({
                user_id: admin.id,
                user_type: 1
              })
            }
          })
        }

        let final_pickup_lat = values.pickup_latitude;
        let final_pickup_lng = values.pickup_longitude;
        let final_pickup_address = values.pickup_address;

        if (isLocalStyleService(values.service_type)) {
          const isPlaceholderAddress = (addr) => {
            const trimmed = String(addr || '').trim();
            return !trimmed || trimmed === '-';
          };
          const formatPickupLocation = ({ address, landmark, postal_code } = {}) => {
            let result = String(address || '').trim();
            if (!result || result === '-') result = '';
            const lm = String(landmark || '').trim();
            const pc = String(postal_code || '').trim();
            if (lm && lm !== '-' && !result.toLowerCase().includes(lm.toLowerCase())) {
              result = result ? `${result}, ${lm}` : lm;
            }
            if (pc && pc !== '-' && !result.includes(pc)) {
              result = result ? `${result}, ${pc}` : pc;
            }
            return result || null;
          };

          if (values.localstatus === 1 && values.sender) {
            final_pickup_lat = values.sender.latitude || null;
            final_pickup_lng = values.sender.longitude || null;
            final_pickup_address = isPlaceholderAddress(values.sender.address)
              ? null
              : formatPickupLocation(values.sender);
          } else if (values.localstatus === 2 && values.sender) {
            final_pickup_lat = values.sender.current_latitude || values.pickup_latitude || null;
            final_pickup_lng = values.sender.current_longitude || values.pickup_longitude || null;
            const currentBase =
              (!isPlaceholderAddress(values.sender.current_location_name)
                ? values.sender.current_location_name
                : null) ||
              values.pickup_address ||
              (!isPlaceholderAddress(values.sender.address) ? values.sender.address : null) ||
              null;
            final_pickup_address = formatPickupLocation({
              address: currentBase,
              landmark: values.sender.landmark,
              postal_code: values.sender.postal_code,
            });
          } else if (values.localstatus === 3 && values.sender) {
            final_pickup_lat = values.sender.current_latitude || values.pickup_latitude || null;
            final_pickup_lng = values.sender.current_longitude || values.pickup_longitude || null;
            final_pickup_address =
              values.sender_search_location ||
              formatPickupLocation({
                address: values.pickup_address || values.sender.address,
                landmark: values.sender.landmark,
                postal_code: values.sender.postal_code,
              }) ||
              null;
          }
        }

        // Calculate distance at submit time (reliable, not dependent on background effect timing)
        let calculatedDistance = values.distance;
        if (isLocalStyleService(values.service_type) && window.google) {
          try {
            let origin = null;
            if (values.localstatus === 1) {
              origin = (values.sender?.latitude && values.sender?.longitude)
                ? { lat: parseFloat(values.sender.latitude), lng: parseFloat(values.sender.longitude) }
                : values.sender?.address;
            } else if (values.localstatus === 2) {
              // use current_lat/lng if available, else fall back to registered address
              origin = (values.sender?.current_latitude && values.sender?.current_longitude)
                ? { lat: parseFloat(values.sender.current_latitude), lng: parseFloat(values.sender.current_longitude) }
                : values.sender?.address;
            } else if (values.localstatus === 3) {
              origin = (values.pickup_latitude && values.pickup_longitude)
                ? { lat: parseFloat(values.pickup_latitude), lng: parseFloat(values.pickup_longitude) }
                : values.pickup_address;
            }
            const destAddr = typeof values.destination === 'string'
              ? values.destination
              : (values.destination?.branch_address || values.destination?.destination_name || values.destination?.branch_name || values.destination?.address);
            if (origin && destAddr) {
              const dist = await calculateDistanceAsync(origin, destAddr);
              if (dist) {
                calculatedDistance = dist;
                setFieldValue('distance', dist);
              }
            }
          } catch (e) {
            console.warn('Distance calc error at submit:', e);
          }
        }

        // Recalculate total for local bookings in case background calculation hasn't finished
        let finalFreight = values.freight;
        let finalTotal = values.total;
        if (isLocalStyleService(values.service_type) && values.vehicle) {
          const basic = parseFloat(values.vehicle.basic_price) || 0;
          const perKm = parseFloat(values.vehicle.per_km_price) || 0;
          const minKm = parseFloat(values.vehicle.minimum_km) || 1;
          const dist = parseFloat(calculatedDistance) || 0;
          const freightTotal = (basic + (perKm * Math.max(0, dist - minKm))).toFixed(2);
          finalFreight = freightTotal;
          finalTotal = freightTotal;
        }

        const payload = {
          ...values,
          distance: calculatedDistance,
          freight: finalFreight,
          total_charge: finalFreight,
          total: finalTotal,
          localstatus: isLocalStyleService(values.service_type) ? values.localstatus : null,
          pickup_latitude: final_pickup_lat,
          pickup_longitude: final_pickup_lng,
          pickup_address: final_pickup_address,
          sender_search_location: values.sender_search_location,
          added_by: user?.id,
          branch_id: values.destination?.id || null,
          driver_id: values.driver?.id || null,
          vehicle_id: values.vehicle?.id || null,
          receiver_id: values.receiver?.id || null,
          receiver_address_id: values.receiverAddress?.id || null,
          receiverAddress: values.receiverAddress || null,
          // Prefer selected address snapshot so listing/trips update on edit
          door_delivery_destination: values.receiverAddress
            ? [values.receiverAddress.address, values.receiverAddress.landmark, values.receiverAddress.city]
                .filter(Boolean)
                .join(', ')
            : (values.door_delivery_destination || null),
          godown_delivery_destination_id:
            values.godown_delivery_destination_id || null,
          derivedDestination:
            isLocalStyleService(localServiceType)
              ? derivedDestination?.branch_name || // from navigation state (add)
              currentUser?.derivedDestination || // from DB (edit)
              ''
              : '',
          invoice_no: values.invoice_no || null,
          invoice_value: values.invoice_value || null,
          sender_phone: values.sender_phone || null,
          receiver_phone: values.receiver_phone || null,
          receiver_name: isLocalStyleService(values.service_type) ? (values.receiver_name?.trim() || null) : null,
          service_type: values.service_type,
          trip_id: values.trip?.id || null,
          delivery_status: values.delivery_status || null,
          payment_status: values.payment_status || 1,
          id: currentUser?.id || Date.now(),
          // Add bookingnewid field for branch users
          bookingnewid: values.bookingNo || null,
          // Notification targeting information for backend
          notification_targets: notificationTargets,
          notification_title: isEdit ? 'Booking Updated' : 'New Booking Created',
          notification_message: isEdit
            ? `Booking ${values.bookingNo || '#'} has been updated by ${user?.name || 'Admin'}`
            : `New booking ${values.bookingNo || '#'} has been created by ${user?.name || 'Admin'}`,
          // isCustomer:user_type === 2 ? true:false,
          // date: formatDate(new Date()),
        }

        console.log('📦 Prepared payload:', payload)
        console.log('🔔 Notification targets:', notificationTargets)

        // Log specific fields that might be causing issues for transhipment users
        console.log('🔍 Key payload fields for transhipment user:');
        console.log('  - invoice_no:', payload.invoice_no);
        console.log('  - invoice_value:', payload.invoice_value);
        console.log('  - freight:', payload.freight);
        console.log('  - surcharge:', payload.surcharge);
        console.log('  - stationary:', payload.stationary);
        console.log('  - handling:', payload.handling);
        console.log('  - demurrage:', payload.demurrage);
        console.log('  - door_collect:', payload.door_collect);
        console.log('  - door_delivery:', payload.door_delivery);
        console.log('  - insurance:', payload.insurance);
        console.log('  - total_charge:', payload.total_charge);
        console.log('  - tax:', payload.tax);
        console.log('  - total:', payload.total);

        // const res = await axios.post(
        //   `${REST_API}bookings/${isEdit ? 'update' : 'add'}-bookings`,
        //   payload,
        // )

        const isOutstation = payload.service_type === 2
        console.log('🌍 Service type:', payload.service_type, 'Is outstation:', isOutstation)

        // Show confirmation dialog for local/passenger bookings (Skip for Admin side)
        if (isLocalStyleService(payload.service_type) && !openLocalConfirm && (user?.user_type == 2 || user?.user_type == 7)) {
          console.log('📝 Local-style booking detected, showing confirmation dialog...');
          setPendingPayload(payload);
          setPendingHelpers({ setSubmitting, resetForm, setErrors });
          setOpenLocalConfirm(true);
          setSubmitting(false);
          return;
        }

        const apiEndpoint = `${REST_API}bookings/${isEdit
          ? 'update-bookings'
          : isOutstation
            ? 'add-outstation-bookings'
            : 'add-bookings'
          }`

        console.log('🌐 API endpoint:', apiEndpoint)
        console.log('📡 Making API request...')

        // Check if form has validation errors before submitting
        if (Object.keys(errors).length > 0) {
          console.log('❌ Form has validation errors, not submitting:', errors);
          enqueueSnackbar('Please fix form errors before submitting', { variant: 'error' });
          setSubmitting(false);
          return;
        }

        // Additional check for transhipment users - ensure all required fields are filled
        if (user?.user_type === 8) {
          console.log('🚛 Transhipment user detected - checking required fields...');
          const requiredFields = ['freight', 'surcharge', 'stationary', 'handling', 'demurrage', 'door_collect', 'door_delivery', 'insurance', 'total_charge', 'tax', 'total'];
          const missingFields = requiredFields.filter(field => !payload[field] || payload[field] === '' || payload[field] === null);

          if (missingFields.length > 0) {
            console.log('❌ Transhipment user missing required fields:', missingFields);
            enqueueSnackbar(`Please fill all required fields: ${missingFields.join(', ')}`, { variant: 'error' });
            setSubmitting(false);
            return;
          }
          console.log('✅ All required fields filled for transhipment user');
        }

        const res = await axios.post(apiEndpoint, payload)

        console.log('✅ API response received:', res.data)

        if ((res.data.status === 1 || res.data.status === 2) && isApprovalMode) {
          console.log('🔔 Approval mode active - triggering formal approval...');
          try {
            const approveRes = await axios.post(`${REST_API}bookings/approve-booking`, {
              id: payload.id,
              userId: user?.id,
            });
            if (approveRes.data.status === 1) {
              console.log('✅ Formal approval successful');
            } else {
              console.warn('⚠️ Formal approval API returned non-success:', approveRes.data);
            }
          } catch (approveError) {
            console.error('❌ Formal approval API call failed:', approveError);
          }
        }

        // setSavedUser(formattedQuotations);
        if (res.data.status === 1) {
          console.log('🎉 Booking operation successful!')
          console.log('📊 Response status:', res.data.status)
          console.log('💬 Response message:', res.data.message)

          enqueueSnackbar(
            isEdit
              ? 'Booking updated successfully'
              : 'Booking created successfully',
            { variant: 'success' },
          )
          resetForm()
          setSubmitting(false)
          onClose()
          // Refresh list after dialog closes (paginated, non-blocking)
          if (typeof fetchBookings === 'function') {
            fetchBookings(true)
            // Local/Passenger auto-trip sets Pending Acceptance in background after the create
            // response — refetch shortly so the driver-acceptance timer appears.
            if (isLocalStyleService(payload.service_type)) {
              setTimeout(() => fetchBookings(true), 1200)
            }
          }
          // ✅ force localServiceType  to 2 after success if it was 1
          if (isLocalStyleService(localServiceType)) setLocalServiceType(2)
        } else if (res.data.status === 2) {
          console.log('ℹ️ No changes applied')
          console.log('📊 Response status:', res.data.status)
          console.log('💬 Response message:', res.data.message)

          enqueueSnackbar(res.data.message || 'No changes applied', {
            variant: 'info',
          })
          setSubmitting(false)
          onClose()
          if (typeof fetchBookings === 'function') {
            fetchBookings(true)
          }
        } else {
          console.log('❌ Booking operation failed')
          console.log('📊 Response status:', res.data.status)
          console.log('💬 Response message:', res.data.message)

          enqueueSnackbar(res.data.message || 'Operation failed', {
            variant: 'error',
          })
          setSubmitting(false)
        }
      } catch (error) {
        console.error('💥 Error in booking submission:', error)
        console.error('🔍 Error details:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
          config: error.config
        })
        setSubmitting(false)
        setErrors(error)
      }
    },
  })

  const {
    values,
    errors,
    touched,
    handleSubmit,
    submitForm,
    getFieldProps,
    setFieldValue,
    isSubmitting,
  } = formik

  const isPassengerDirectConfirm =
    !isEdit &&
    Number(user?.user_type) === 7 &&
    isPassengerService(localServiceType) &&
    Boolean(currentUser?.skipAddBookingForm)

  const isPassengerMobileReview =
    isPassengerDirectConfirm &&
    shouldUsePassengerMobileFlow(user, localServiceType, isMobile)

  const passengerDirectConfirmStartedRef = useRef(false)

  // Keep vehicle in sync once options load (SelectVehicle → Add Booking)
  useEffect(() => {
    if (isEdit) return;
    if (!initialVehicle || values.vehicle?.id === initialVehicle.id) return;
    setFieldValue('vehicle', initialVehicle);
  }, [initialVehicle, isEdit, setFieldValue, values.vehicle?.id]);

  useEffect(() => {
    if (!isPassengerDirectConfirm || passengerDirectConfirmStartedRef.current || openLocalConfirm) {
      return undefined
    }
    // Wait for booking number generation (avoids stale/duplicate BOOK ids)
    if (loadingBookingId) return undefined
    if (!values.bookingNo) return undefined
    // Prefer count-based ID when available; otherwise nextBookingId must be ready
    if (customerBookingCount === null && (!nextBookingId || nextBookingId <= 1)) {
      return undefined
    }
    if (!values.sender?.id || !values.vehicle?.id || !values.destination) return undefined
    // Wait for booking count so we don't auto-submit with default BOOK001
    if (loadingBookingId) return undefined

    const readyBookingId = generateBookingId(branchBookingCount)
    if (values.bookingNo !== readyBookingId) {
      setFieldValue('bookingNo', readyBookingId)
      return undefined
    }

    passengerDirectConfirmStartedRef.current = true
    // Refresh booking number one last time before auto-submit
    const freshId = generateBookingId(branchBookingCount)
    if (freshId && freshId !== values.bookingNo) {
      setFieldValue('bookingNo', freshId)
    }
    const timer = setTimeout(() => {
      submitForm()
    }, 500)
    return () => clearTimeout(timer)
  }, [
    isPassengerDirectConfirm,
    openLocalConfirm,
    loadingBookingId,
    customerBookingCount,
    nextBookingId,
    values.bookingNo,
    values.sender?.id,
    values.vehicle?.id,
    values.destination,
    values.bookingNo,
    loadingBookingId,
    customerBookingCount,
    nextBookingId,
    branchBookingCount,
    submitForm,
    setFieldValue,
  ])

  useEffect(() => {
    console.log('useEffect triggered - userDetails:', userDetails, 'isEdit:', isEdit);
    if (user && !isEdit) {
      const newBookingId = generateBookingId(branchBookingCount);
      console.log('Setting new booking ID:', newBookingId);
      setFieldValue('bookingNo', newBookingId);
    }
  }, [userDetails, user, isEdit, setFieldValue, branchList, branchBookingCount, customerBookingCount, nextBookingId]);

  // Update booking ID when user object changes (in case branch_code is in user object)
  useEffect(() => {
    console.log('User useEffect triggered - user:', user, 'isEdit:', isEdit);
    if (user && !isEdit && user.user_type === 5) {
      const newBookingId = generateBookingId(branchBookingCount);
      console.log('Setting new booking ID from user object:', newBookingId);
      setFieldValue('bookingNo', newBookingId);
    }
  }, [user, isEdit, setFieldValue, branchList, branchBookingCount]);

  // Update booking ID when branchList changes (for branch users)
  useEffect(() => {
    console.log('BranchList useEffect triggered - branchList:', branchList, 'user:', user, 'isEdit:', isEdit);
    if (branchList && branchList.length > 0 && user && !isEdit && user.user_type === 5) {
      const newBookingId = generateBookingId(branchBookingCount);
      console.log('Setting new booking ID from branchList:', newBookingId);
      setFieldValue('bookingNo', newBookingId);
    }
  }, [branchList, user, isEdit, setFieldValue, branchBookingCount]);

  // Update booking ID when branch booking count changes
  useEffect(() => {
    console.log('BranchCount useEffect triggered - branchBookingCount:', branchBookingCount, 'user:', user, 'isEdit:', isEdit);
    if (branchBookingCount !== null && user && !isEdit && user.user_type === 5) {
      const newBookingId = generateBookingId(branchBookingCount);
      console.log('Setting new booking ID from branch count:', newBookingId);
      setFieldValue('bookingNo', newBookingId);
    }
  }, [branchBookingCount, user, isEdit, setFieldValue]);

  // Update formik values when selectedModeOfDelivery or selectedPaymentStatus change
  useEffect(() => {
    if (formik) {
      setFieldValue('delivery_status', selectedModeOfDelivery?.id || null);
      setFieldValue('payment_status', selectedPaymentStatus?.id || 1);
    }
  }, [selectedModeOfDelivery, selectedPaymentStatus, setFieldValue]);


  // ⬇️ Put these near your other hooks (after `const { values, setFieldValue } = formik` is available)

  const toNum = (v) => (v === '' || v === null || v === undefined ? 0 : parseFloat(v) || 0);

  useEffect(() => {
    const total =
      toNum(values.freight) +
      toNum(values.surcharge) +
      toNum(values.stationary) +
      toNum(values.handling) +
      toNum(values.demurrage) +
      toNum(values.door_collect) +
      toNum(values.door_delivery) +
      toNum(values.insurance);

    // avoid extra renders if unchanged
    if (String(values.total_charge) !== total.toFixed(2)) {
      setFieldValue('total_charge', total.toFixed(2), false);
    }
  }, [
    values.freight,
    values.surcharge,
    values.stationary,
    values.handling,
    values.demurrage,
    values.door_collect,
    values.door_delivery,
    values.insurance,
    setFieldValue,
  ]);

  useEffect(() => {
    try {
      console.log('🔄 Distance Effect Triggered', {
        localServiceType,
        isLoaded,
        hasGoogle: !!window.google,
        hasSender: !!values.sender,
        hasDest: !!values.destination
      });

      if (isLocalStyleService(localServiceType) && isLoaded && window.google && values.sender && values.destination) {
        console.log('🚀 STARTING Distance Calculation', {
          sender: values.sender,
          destination: values.destination
        });

        let sLat = null;
        let sLng = null;
        let sAddr = null;

        if (values.localstatus === 1) {
          sLat = values.sender.latitude;
          sLng = values.sender.longitude;
          sAddr = values.sender.address;
        } else if (values.localstatus === 2) {
          sLat = values.sender.current_latitude;
          sLng = values.sender.current_longitude;
          // fallback to registered address if no current coordinates
          sAddr = values.sender.address;
        } else if (values.localstatus === 3) {
          sLat = values.pickup_latitude || values.sender?.current_latitude;
          sLng = values.pickup_longitude || values.sender?.current_longitude;
          sAddr = values.pickup_address || values.sender_search_location || values.sender?.address;
        }

        const destAddr = typeof values.destination === 'string'
          ? values.destination
          : (values.destination.branch_address || values.destination.destination_name || values.destination.branch_name || values.destination.address);

        // Fallback to sender address if coordinates are missing
        const senderSource = (sLat && sLng)
          ? { lat: parseFloat(sLat), lng: parseFloat(sLng) }
          : sAddr;

        console.log('📍 Data for Google:', {
          localstatus: values.localstatus,
          sLat, sLng, sAddr,
          senderSource,
          destAddr,
          senderObj: values.sender,
        });

        if (senderSource && destAddr) {
          if (!window.google.maps || !window.google.maps.DistanceMatrixService) {
            console.error('❌ Google Maps DistanceMatrixService not available yet');
            return;
          }

          const service = new window.google.maps.DistanceMatrixService();
          console.log('🛰️ Service created, calling getDistanceMatrix...');

          service.getDistanceMatrix(
            {
              origins: [senderSource],
              destinations: [destAddr],
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (response, status) => {
              console.log('🗺️ Google Response:', { status, response });
              if (status === 'OK' && response.rows[0].elements[0].status === 'OK') {
                const distanceInKm = (response.rows[0].elements[0].distance.value / 1000).toFixed(2);
                console.log('✅ Success! Distance:', distanceInKm);
                setFieldValue('distance', distanceInKm);
              } else {
                console.warn('❌ Google returned error or no route:', status, response?.rows?.[0]?.elements?.[0]?.status);
              }
            }
          );
        } else {
          console.warn('⚠️ Missing required data:', { senderSource, destAddr });
        }
      }
    } catch (err) {
      console.error('❌ ERROR in Distance Effect:', err);
    }
  }, [localServiceType, isLoaded, values.sender, values.destination, values.localstatus, values.pickup_latitude, values.pickup_longitude, values.pickup_address, setFieldValue, values.vehicle]);

  useEffect(() => {
    if (isLocalStyleService(localServiceType) && values.vehicle && values.distance) {
      const basic = parseFloat(values.vehicle.basic_price) || 0;
      const perKm = parseFloat(values.vehicle.per_km_price) || 0;
      const minKm = parseFloat(values.vehicle.minimum_km) || 1;
      const dist = parseFloat(values.distance) || 0;
      const freightTotal = basic + (perKm * Math.max(0, dist - minKm));

      if (String(values.freight) !== freightTotal.toFixed(2)) {
        setFieldValue('freight', freightTotal.toFixed(2));
      }

      // Auto-generate invoice number for local booking
      if (!values.invoice_no && values.bookingNo) {
        setFieldValue('invoice_no', `INVL${values.bookingNo}`);
      }
    } else if (isLocalStyleService(localServiceType) && !values.invoice_no && values.bookingNo) {
      setFieldValue('invoice_no', `INVL${values.bookingNo}`);
    }
  }, [localServiceType, values.vehicle, values.distance, values.bookingNo, setFieldValue, values.invoice_no]);



  // const filteredReceivers = customers.filter(
  //   (c) => !values.sender || c.id !== values.sender.id,
  // )
  // const filteredSenders = customers.filter(
  //   (c) => !values.receiver || c.id !== values.receiver.id,
  // )
  const filteredSenders = useMemo(
    () =>
      customerOptions.filter(
        (c) => c.customer_type === 1 && (!values.receiver || c.id !== values.receiver.id),
      ),
    [customerOptions, values.receiver],
  )

  const senderOptions = useMemo(() => {
    // Passenger self-booking: only their own profile (do not offer customers list)
    if (Number(user?.user_type) === 7) {
      const self = currentUser?.sender || location.state?.selectedSender
      return self?.id ? [self] : []
    }
    const options = [...filteredSenders, ...additionalSenders];
    if (location.state?.selectedSender) {
      const exists = options.find(
        (s) => s.id === location.state.selectedSender.id && s.address === location.state.selectedSender.address
      );
      if (!exists) {
        options.push(location.state.selectedSender);
      }
    }
    return [1, 5].includes(Number(user?.user_type))
      ? [
          { id: 'add-sender', first_name: 'Add', last_name: 'Sender' },
          ...options,
        ]
      : options;
  }, [filteredSenders, additionalSenders, location.state?.selectedSender, user?.user_type, currentUser?.sender]);

  // Outstation (service_type 2): only logged-in customers are filtered by users.added_by.
  // Admin and Branch users receive all active receivers.
  // Local (service_type 1): keep existing customer_type === 2 filter (unused by Local UI).
  const fetchOutstationReceivers = useCallback(async () => {
    try {
      const res = await axios.post(
        `${REST_API}customers/get-customer-added-by-customer`,
        {
          service_type: 2,
          added_by: user?.id,
          user_type: user?.user_type,
        },
      )
      const list = res.data.status === 1 ? res.data.data : []
      setOutstationReceivers(list)
      return list
    } catch (error) {
      console.error('Error fetching outstation receivers:', error)
      setOutstationReceivers([])
      return []
    }
  }, [user?.id, user?.user_type])

  useEffect(() => {
    if (Number(localServiceType) === 2) {
      fetchOutstationReceivers()
    } else {
      setOutstationReceivers([])
    }
  }, [localServiceType, fetchOutstationReceivers])

  // When receivers list loads on edit, attach addresses from the list onto the selected receiver
  useEffect(() => {
    if (!isEdit || !values.receiver?.id || !outstationReceivers.length) return
    const existing = Array.isArray(values.receiver.addresses) ? values.receiver.addresses : []
    if (existing.length > 0) return

    const match = outstationReceivers.find(
      (r) => String(r.id) === String(values.receiver.id)
    )
    if (!match || !Array.isArray(match.addresses) || !match.addresses.length) return

    setFieldValue('receiver', { ...values.receiver, addresses: match.addresses })
    const selectedId = values.receiverAddress?.id || currentUser?.receiver_address_id || null
    if (selectedId) {
      const addr = match.addresses.find((a) => String(a.id) === String(selectedId))
      if (addr) setFieldValue('receiverAddress', addr)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outstationReceivers, isEdit, values.receiver?.id])

  const handleSenderAdded = useCallback((createdSender) => {
    setOpenAddSenderDialog(false)
    if (!createdSender) return
    setAdditionalSenders((prev) => [...prev, createdSender])
    setFieldValue('sender', createdSender)
    if (createdSender.phone_number) {
      setFieldValue('sender_phone', createdSender.phone_number)
    }
  }, [setFieldValue])

  const handleReceiverAdded = useCallback(async (createdReceiver) => {
    const list = await fetchOutstationReceivers()
    setOpenAddReceiverDialog(false)

    if (!createdReceiver) return

    let match = null
    if (createdReceiver.id) {
      match = list.find((receiver) => String(receiver.id) === String(createdReceiver.id))
    }
    if (!match && createdReceiver.phone_number) {
      match = list.find(
        (receiver) => receiver.phone_number === createdReceiver.phone_number,
      )
    }
    if (match && (!values.sender || match.id !== values.sender.id)) {
      setFieldValue('receiver', match)
      if (match.phone_number) {
        setFieldValue('receiver_phone', match.phone_number)
      }
    }
  }, [fetchOutstationReceivers, setFieldValue, values.sender])

  const filteredReceivers = useMemo(
    () =>
      localServiceType === 1
        ? customerOptions.filter(
            (c) =>
              c.customer_type === 2 &&
              (!values.sender || c.id !== values.sender.id),
          )
        : outstationReceivers.filter(
            (c) => !values.sender || c.id !== values.sender.id,
          ),
    [localServiceType, customerOptions, outstationReceivers, values.sender],
  )

  const receiverOptionsWithAdd = useMemo(
    () =>
      [1, 2, 5].includes(Number(user?.user_type))
        ? [
            { id: 'add-receiver', first_name: 'Add', last_name: 'Receiver' },
            ...filteredReceivers,
          ]
        : filteredReceivers,
    [user?.user_type, filteredReceivers],
  )

  // const calculateTotals = useCallback(() => {
  //   const updatedItems = formik.values.items.map((item) => {
  //     const qty = parseFloat(item.qty) || 0
  //     const weight = parseFloat(item.weight) || 0
  //     const price = qty * weight
  //     return { ...item, price }
  //   })

  // setFieldValue('items', updatedItems, false)

  // const itemTotal = updatedItems.reduce((sum, item) => {
  //   const price = parseFloat(item.price) || 0
  //   return sum + price
  // }, 0)

  // const calculateTotals = useCallback(() => {
  //   const itemTotal = values.items.reduce((sum, item) => {
  //     const price = parseFloat(item.price) || 0
  //     return sum + price
  //   }, 0)

  //   const {
  //     freight,
  //     surcharge,
  //     stationary,
  //     handling,
  //     demurrage,
  //     door_collect,
  //     door_delivery,
  //     insurance,
  //     excludeTax,
  //   } = formik.values

  //   const totalCharge = [
  //     freight,
  //     surcharge,
  //     stationary,
  //     handling,
  //     demurrage,
  //     door_collect,
  //     door_delivery,
  //     insurance,
  //   ].reduce((sum, val) => sum + (parseFloat(val) || 0), 0)

  //   const subtotal = itemTotal + totalCharge
  //   const tax = excludeTax ? 0 : subtotal * 0.18
  //   const total = subtotal + tax

  //   setFieldValue('total_charge', totalCharge.toFixed(2), false)
  //   setFieldValue('subtotal', subtotal.toFixed(2), false)
  //   setFieldValue('tax', tax.toFixed(2), false)
  //   setFieldValue('total', total.toFixed(2), false)
  // }, [formik])

  const qtyList = useMemo(() => (values.items || []).map((i) => i.qty), [values.items])

  const weightList = useMemo(
    () => (values.items || []).map((i) => i.weight),
    [values.items],
  )


  const rowPrices = useMemo(
    () => (values.items || []).map((it) => +(toNum(it.qty) * toNum(it.weight)).toFixed(2)),
    [qtyList, weightList, values.items?.length]
  );

  const bookingTotalPrice = useMemo(
    () => +rowPrices.reduce((sum, p) => sum + (parseFloat(p) || 0), 0).toFixed(2),
    [rowPrices]
  );



  // ⬇️ Auto-set total = subtotal + total_charge + tax
  useEffect(() => {
    const n = (v) => (v === '' || v == null ? 0 : parseFloat(v) || 0);
    const total = n(values.subtotal) + n(values.total_charge) + n(values.tax);
    const totalStr = total.toFixed(2);

    if (String(values.total ?? '') !== totalStr) {
      setFieldValue('total', totalStr, false);
    }
  }, [values.subtotal, values.total_charge, values.tax, setFieldValue]);

  // Edit/open: load receiver addresses so Receiver Address dropdown has options
  useEffect(() => {
    const receiverId = values.receiver?.id
    if (!receiverId || !isOutstationService(localServiceType)) return

    const existing = Array.isArray(values.receiver?.addresses)
      ? values.receiver.addresses.filter((a) => a && (a.id || a.address))
      : []
    if (existing.length > 0) return

    let cancelled = false
    ;(async () => {
      try {
        const res = await axios.post(`${REST_API}customers/get-addresses`, {
          customer_id: receiverId,
        })
        if (cancelled || res.data.status !== 1) return
        const addresses = res.data.data || []
        setFieldValue('receiver', { ...values.receiver, addresses })

        const selectedId =
          values.receiverAddress?.id || currentUser?.receiver_address_id || null
        if (selectedId) {
          const match = addresses.find((a) => String(a.id) === String(selectedId))
          if (match) setFieldValue('receiverAddress', match)
        } else if (values.receiverAddress?.legacy && addresses.length) {
          // Prefer matching by address text when edit used a synthetic legacy value
          const text = String(values.receiverAddress.address || '').toLowerCase()
          const match =
            addresses.find((a) => String(a.address || '').toLowerCase() === text) ||
            addresses.find((a) =>
              text.includes(String(a.landmark || '').toLowerCase()) ||
              text.includes(String(a.address || '').toLowerCase())
            )
          if (match) setFieldValue('receiverAddress', match)
        }
      } catch (e) {
        console.error('Failed to load receiver addresses on edit', e)
      }
    })()

    return () => {
      cancelled = true
    }
    // intentionally depend on receiver id only — avoid re-fetch loops when addresses attach
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.receiver?.id, localServiceType])


  // useEffect(() => {
  //   // calculateTotals()
  // }, [
  //   ...qtyList,
  //   ...weightList,
  //   values.freight,
  //   values.surcharge,
  //   values.stationary,
  //   values.handling,
  //   values.demurrage,
  //   values.door_collect,
  //   values.door_delivery,
  //   values.insurance,
  //   // values.excludeTax,
  // ])

  const handleDecimalInput = (e) => {
    const { value } = e.target

    // Only allow valid decimal format (max 2 decimals)
    const regex = /^\d*\.?\d{0,2}$/

    if (!regex.test(value)) {
      e.preventDefault()
    }
  }

  const destinationOptions =
    isLocalStyleService(localServiceType) && derivedDestination
      ? [...branchList, derivedDestination]
      : branchList

  const handleFinalConfirm = async () => {
    if (isSubmittingRef.current) return;
    if (!pendingPayload || !pendingHelpers) return;
    isSubmittingRef.current = true;
    const { setSubmitting, resetForm } = pendingHelpers;

    try {
      setIsConfirmLoading(true);
      setSubmitting(true);
      const isOutstation = pendingPayload.service_type === 2;
      const apiEndpoint = `${REST_API}bookings/${isEdit
        ? 'update-bookings'
        : isOutstation
          ? 'add-outstation-bookings'
          : 'add-bookings'
        }`;

      const res = await axios.post(apiEndpoint, pendingPayload);

      if (res.data.status === 1) {
        enqueueSnackbar(isEdit ? 'Booking updated successfully' : 'Booking created successfully', { variant: 'success' });
        const createdBookingId = res.data.booking_id;
        resetForm();
        setOpenLocalConfirm(false);
        setSubmitting(false);
        onClose();
        if (typeof fetchBookings === 'function') {
          fetchBookings(true);
          if (isLocalStyleService(pendingPayload.service_type)) {
            setTimeout(() => fetchBookings(true), 1200);
          }
        }
        if (isLocalStyleService(localServiceType)) setLocalServiceType(2);

        // PASSENGER (Mobile + Desktop): Navigate to dedicated Ride Status screen on creation
        const isPassengerBooking =
          isPassengerUser(user) &&
          isPassengerService(pendingPayload.service_type ?? localServiceType);

        if (!isEdit && isPassengerBooking && createdBookingId) {
          const targetUrl =
            typeof PATH_DASHBOARD?.general?.passengerRideStatus === 'function'
              ? PATH_DASHBOARD.general.passengerRideStatus(createdBookingId)
              : `/dashboard/passenger/ride/${createdBookingId}`;
          navigate(targetUrl);
        }
      } else {
        enqueueSnackbar(res.data.message || 'Operation failed', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error in final confirmation:', error);
      enqueueSnackbar('Error submitting booking', { variant: 'error' });
    } finally {
      setSubmitting(false);
      setIsConfirmLoading(false);
      isSubmittingRef.current = false;
    }
  };


  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        {/* Passenger service only — loader while preparing confirmation (no white card) */}
        {isPassengerDirectConfirm && !openLocalConfirm && (
          <Box
            sx={{
              minHeight: 280,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LoadingScreen style={{ backgroundColor: 'transparent', height: 'auto', minHeight: 180 }} />
          </Box>
        )}

        {!isPassengerDirectConfirm && (
        <Card sx={{ p: 3, boxShadow: 'none' }}>
          <Stack container gap={2} direction="column">
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={2}
              alignContent={'center'}
            >
              <TextField
                fullWidth
                label="Booking No"
                value={values.bookingNo}
                InputProps={{ readOnly: true }}
              />



              {/* <Autocomplete
                    options={branchList}
                    fullWidth
                    // getOptionLabel={(option) => `${option.id} ${option.branch_name}`}
                    getOptionLabel={(option) =>
                      `${option.branch_name} (${option.branch_code})`
                    }
                    value={values.destination}
                    onChange={(_, newValue) =>
                      setFieldValue('destination', newValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Destination"
                        fullWidth
                        error={
                          touched.destination && Boolean(errors.destination)
                        }
                        InputProps={{
                          readOnly: localServiceType  === 1 && !!derivedDestination,
                        }}
                      />
                    )}
                  /> */}
              {(isLocalStyleService(localServiceType)) &&
                (location.state?.derivedDestination ||
                  currentUser?.derivedDestination ? (
                  <TextField
                    fullWidth
                    label="Destination"
                    value={
                      location.state?.derivedDestination?.branch_name ||
                      currentUser?.derivedDestination ||
                      ''
                    }
                    InputProps={{ readOnly: true }}
                  />
                ) : user?.user_type !== 5 ? (
                  <Autocomplete
                    options={destinationOptions}
                    fullWidth
                    getOptionLabel={(option) =>
                      option?.branch_name
                        ? `${option.branch_name}${option.branch_code ? ` (${option.branch_code})` : ''
                        }`
                        : ''
                    }
                    value={values.destination}
                    onChange={(_, newValue) =>
                      setFieldValue('destination', newValue)
                    }
                    isOptionEqualToValue={(option, value) =>
                      option && value && String(option.id) === String(value.id)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Destination"
                        fullWidth
                        required
                        error={
                          touched.destination && Boolean(errors.destination)
                        }
                      />
                    )}
                  />
                ) : (
                  <TextField
                    fullWidth
                    label="Destination"
                    value="Admin will assign destination"
                    InputProps={{ readOnly: true }}
                    helperText="Only admin can assign destination"
                  />
                ))}

              {((isLocalStyleService(localServiceType)) || (localServiceType === 2 && user?.user_type !== 1)) && user?.user_type !== 5 && (
                <>
                  {user?.user_type !== 2 && user?.user_type !== 7 && (
                    <Autocomplete
                      options={vehiclesOptions.filter((v) => {
                        // LOCAL — catalog already scoped by API (service_type=1); show Local rows only
                        if (Number(localServiceType) === SERVICE_TYPE.LOCAL) {
                          return !!v.isLocal
                        }
                        // PASSENGER — catalog from passenger_vehicles; do not apply Local name denylist
                        if (isPassengerService(localServiceType)) {
                          return !!v.isLocal
                        }
                        // OUTSTATION — trucks only
                        return !v.isLocal
                      })}
                      getOptionLabel={(option) => {
                        if (option?.isLocal) {
                          const basic = option?.basic_price
                          const hasPricing = basic !== null && basic !== undefined && basic !== ''
                          return option?.vehicle_name && hasPricing
                            ? `${option.vehicle_name} (Basic: ₹${option.basic_price} [${option.minimum_km || 1} km], ₹${option.per_km_price}/extra km)`
                            : option?.vehicle_name || ''
                        } else {
                          return option?.vehicle_no && option?.vehicle_type
                            ? `${option.vehicle_no} (${option.vehicle_type})`
                            : option?.vehicle_no || ''
                        }
                      }}
                      value={values.vehicle}
                      isOptionEqualToValue={(option, value) =>
                        option?.id == value?.id && !!option?.isLocal === !!value?.isLocal
                      }
                      fullWidth
                      loading={loadingVehicles}
                      onChange={(_, newValue) => setFieldValue('vehicle', newValue)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Vehicle Type"
                          fullWidth
                          error={touched.vehicle && Boolean(errors.vehicle)}
                          helperText={touched.vehicle && Boolean(errors.vehicle) && (typeof errors.vehicle === 'string' ? errors.vehicle : errors.vehicle?.id || 'Vehicle is required')}
                        />
                      )}
                    />
                  )}
                </>
              )}

              {/* Distance field moved from here to next row */}

              {/* {localServiceType  === 2 && (
                <> */}
              {/* <Autocomplete
                    options={tripList}
                    fullWidth
                    // getOptionLabel={(option) =>
                    //   option?.trip_no
                    //     ? `TMS${option.trip_no.toString().padStart(3, '0')}`
                    //     : ''
                    // }
                    getOptionLabel={(option) =>
                      `TMS${option.trip_no.toString().padStart(3, '0')}`
                    }
                    value={values.trip}
                    onChange={(_, newValue) => setFieldValue('trip', newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Trip"
                        fullWidth
                        error={touched.trip && Boolean(errors.trip)}
                        helperText={touched.trip && (typeof errors.trip === 'string' ? errors.trip : errors.trip?.id || 'Trip is required')}
                      />
                    )}
                  /> */}

              {/* </>
              )} */}

              {/* {user?.user_type === 2 ? (
                <TextField
                  fullWidth
                  label="Sender"
                  value={values.sender || ''}
                  InputProps={{ readOnly: true }}
                />
              ) : ( */}
              {isPassengerBookingEdit ? (
                <TextField
                  fullWidth
                  required
                  label="Passenger Name"
                  value={values.passenger_name || ''}
                  onChange={(e) => {
                    const name = e.target.value
                    setFieldValue('passenger_name', name)
                    setFieldValue('sender', {
                      ...(values.sender || { id: currentUser?.sender_id }),
                      first_name: name,
                      last_name: '',
                      user_name: name,
                    })
                  }}
                  error={touched.passenger_name && Boolean(errors.passenger_name)}
                  helperText={touched.passenger_name && errors.passenger_name}
                />
              ) : (
              <Autocomplete
                options={senderOptions}
                fullWidth
                value={values.sender}
                inputValue={senderInputValue}
                onInputChange={(_, newInput, reason) => {
                  // Keep input controlled so local filter always sees real typed text
                  if (reason === 'reset' && values.localstatus === 3 && values.sender_search_location && values.sender) {
                    const name = `${values.sender.first_name || values.sender.user_name || ''} ${values.sender.last_name || ''}`.trim()
                    setSenderInputValue(`${name || 'Sender'} (${values.sender_search_location})`)
                    return
                  }
                  setSenderInputValue(newInput)
                }}
                getOptionLabel={getSenderOptionLabel}
                filterOptions={(options, params) => {
                  const addOption = options.find((o) => o.id === 'add-sender')
                  const rest = options.filter((o) => o.id !== 'add-sender')
                  // Use controlled input (params.inputValue can be blanked by MUI when pristine)
                  const filtered = filterSenderOptions(rest, {
                    ...params,
                    inputValue: senderInputValue,
                  })
                  return addOption ? [addOption, ...filtered] : filtered
                }}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false
                  if (option.id === 'add-sender' && value?.id === 'add-sender') return true
                  return option.id === value.id && option.address === value.address
                }}
                renderOption={(props, option) => {
                  if (option.id === 'add-sender') {
                    return (
                      <li {...props} key="add-sender">
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Stack className="lets-icons--add-duotone" sx={{ color: 'primary.main' }} />
                          <Typography color="primary" variant="subtitle2">Add Sender</Typography>
                        </Stack>
                      </li>
                    )
                  }
                  return (
                    <li {...props} key={`${option.id}-${option.address || ''}`}>
                      <Typography variant="body2">
                        {getSenderOptionLabel(option)}
                      </Typography>
                    </li>
                  )
                }}
                onChange={(_, newValue) => {
                  if (newValue?.id === 'add-sender') {
                    setOpenAddSenderDialog(true);
                    return;
                  }
                  setFieldValue('sender', newValue);
                  if (newValue?.phone_number) {
                    setFieldValue('sender_phone', newValue.phone_number);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Sender"
                    fullWidth
                    required
                    error={touched.sender && Boolean(errors.sender)}
                    helperText={touched.sender && errors.sender}
                  />
                )}
              />
              )}

              {isOutstationService(localServiceType) && (
                <Autocomplete
                  fullWidth
                  options={receiverOptionsWithAdd}
                  value={values.receiver}
                  inputValue={receiverInputValue}
                  onInputChange={(_, newInput) => setReceiverInputValue(newInput)}
                  getOptionLabel={getReceiverOptionLabel}
                  filterOptions={(options, params) => {
                    const addOption = options.find((o) => o.id === 'add-receiver')
                    const rest = options.filter((o) => o.id !== 'add-receiver')
                    const filtered = filterReceiverOptions(rest, {
                      ...params,
                      inputValue: receiverInputValue,
                    })
                    return addOption ? [addOption, ...filtered] : filtered
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false
                    if (option.id === 'add-receiver' && value?.id === 'add-receiver') return true
                    if (option.id && value.id) return String(option.id) === String(value.id)
                    if (option.address && value.address) return option.address === value.address
                    return false
                  }}
                  renderOption={(props, option) => {
                    if (option.id === 'add-receiver') {
                      return (
                        <li {...props} key="add-receiver">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Stack
                              className="lets-icons--add-duotone"
                              sx={{ color: 'primary.main' }}
                            />
                            <Typography color="primary" variant="subtitle2">
                              Add Receiver
                            </Typography>
                          </Stack>
                        </li>
                      )
                    }

                    return (
                      <li {...props} key={`${option.id}-${option.address || ''}`}>
                        {getReceiverOptionLabel(option)}
                      </li>
                    )
                  }}
                  onChange={async (_, newValue) => {
                    if (newValue?.id === 'add-receiver') {
                      setOpenAddReceiverDialog(true)
                    } else {
                      setFieldValue('receiver', newValue)
                      setFieldValue('receiverAddress', null)
                      if (newValue?.phone_number) {
                        setFieldValue('receiver_phone', newValue.phone_number);
                      }
                      if (newValue?.id && (!Array.isArray(newValue.addresses) || !newValue.addresses.length)) {
                        try {
                          const res = await axios.post(`${REST_API}customers/get-addresses`, {
                            customer_id: newValue.id,
                          })
                          if (res.data.status === 1) {
                            setFieldValue('receiver', { ...newValue, addresses: res.data.data || [] })
                          }
                        } catch (e) {
                          console.error('Failed to load receiver addresses', e)
                        }
                      }
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Receiver"
                      fullWidth
                      required
                      error={touched.receiver && Boolean(errors.receiver)}
                      helperText={touched.receiver && Boolean(errors.receiver) && (typeof errors.receiver === 'string' ? errors.receiver : errors.receiver?.id || 'Receiver is required')}
                    />
                  )}
                />
              )}
              {isOutstationService(localServiceType) && (
                <Autocomplete
                  fullWidth
                  disabled={!values.receiver}
                  options={(() => {
                    const list = Array.isArray(values.receiver?.addresses)
                      ? [...values.receiver.addresses]
                      : []
                    const selected = values.receiverAddress
                    if (
                      selected &&
                      !list.some((a) =>
                        selected.id && a.id
                          ? String(a.id) === String(selected.id)
                          : a.address === selected.address && a.label === selected.label
                      )
                    ) {
                      list.unshift(selected)
                    }
                    return list
                  })()}
                  filterOptions={(options, state) => {
                    const q = (state.inputValue || '').trim().toLowerCase()
                    if (!q) return options
                    return options.filter((option) => {
                      const name = option.label || 'Address'
                      const line = [option.address, option.landmark, option.city]
                        .filter(Boolean)
                        .join(', ')
                      const label = line ? `${name} — ${line}` : name
                      return label.toLowerCase().includes(q)
                    })
                  }}
                  getOptionLabel={(option) => {
                    if (!option) return ''
                    const name = option.label || 'Address'
                    const line = [option.address, option.landmark, option.city].filter(Boolean).join(', ')
                    return line ? `${name} — ${line}` : name
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (option?.id && value?.id) return String(option.id) === String(value.id)
                    return option?.address === value?.address && option?.label === value?.label
                  }}
                  value={values.receiverAddress}
                  onChange={(_, newValue) => {
                    setFieldValue('receiverAddress', newValue)
                    if (newValue) {
                      const snap = [newValue.address, newValue.landmark, newValue.city]
                        .filter(Boolean)
                        .join(', ')
                      setFieldValue('door_delivery_destination', snap || '')
                    }
                  }}
                  onOpen={async () => {
                    // Ensure options are present when opening on edit
                    const receiverId = values.receiver?.id
                    if (!receiverId) return
                    const existing = Array.isArray(values.receiver?.addresses)
                      ? values.receiver.addresses
                      : []
                    if (existing.length > 0) return
                    try {
                      const res = await axios.post(`${REST_API}customers/get-addresses`, {
                        customer_id: receiverId,
                      })
                      if (res.data.status === 1) {
                        const addresses = res.data.data || []
                        setFieldValue('receiver', { ...values.receiver, addresses })
                        const selectedId =
                          values.receiverAddress?.id || currentUser?.receiver_address_id || null
                        if (selectedId) {
                          const match = addresses.find((a) => String(a.id) === String(selectedId))
                          if (match) setFieldValue('receiverAddress', match)
                        }
                      }
                    } catch (e) {
                      console.error('Failed to load addresses on open', e)
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Receiver Address"
                      fullWidth
                      required
                      error={touched.receiverAddress && Boolean(errors.receiverAddress)}
                      helperText={
                        touched.receiverAddress &&
                        Boolean(errors.receiverAddress) &&
                        (typeof errors.receiverAddress === 'string'
                          ? errors.receiverAddress
                          : 'Receiver address is required')
                      }
                    />
                  )}
                />
              )}
            </Stack>

            {isLocalStyleService(localServiceType) && (
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                sx={{ width: '100%' }}
              >
                <TextField
                  fullWidth
                  label={isPassengerBookingEdit ? 'Passenger Number' : 'Sender Phone Number'}
                  {...getFieldProps('sender_phone')}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                  error={touched.sender_phone && Boolean(errors.sender_phone)}
                  helperText={touched.sender_phone && errors.sender_phone}
                />
                {!isPassengerBookingEdit && (
                  <>
                    <TextField
                      fullWidth
                      label="Receiver Name"
                      required
                      {...getFieldProps('receiver_name')}
                      error={touched.receiver_name && Boolean(errors.receiver_name)}
                      helperText={touched.receiver_name && errors.receiver_name}
                    />
                    <TextField
                      fullWidth
                      label="Receiver Phone Number"
                      {...getFieldProps('receiver_phone')}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                      }}
                      error={touched.receiver_phone && Boolean(errors.receiver_phone)}
                      helperText={touched.receiver_phone && errors.receiver_phone}
                    />
                  </>
                )}
              </Stack>
            )}
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={2}
              alignItems="flex-start"
              sx={{ width: '100%' }}
            >
              {!isPassengerBookingEdit && (
              <Autocomplete
                fullWidth
                options={isLocalStyleService(localServiceType)
                  ? modeOfDeliveryOptions.filter(opt => opt.id === 1)
                  : modeOfDeliveryOptions
                }
                getOptionLabel={(option) => option.name}
                value={values.delivery_status ? modeOfDeliveryOptions.find(opt => opt.id === values.delivery_status) : null}
                onChange={(_, newValue) => {
                  setFieldValue('delivery_status', newValue?.id || null);
                  setSelectedModeOfDelivery(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Mode of Delivery"
                    fullWidth
                    required
                    error={Boolean(touched.delivery_status && errors.delivery_status)}
                    helperText={touched.delivery_status && errors.delivery_status}
                  />
                )}
              />
              )}

              {/* Distance field removed as per user request */}
              {/* {localServiceType  === 2 && ( */}
              {/* <> */}
              {/* {selectedModeOfDelivery?.id === 1 && (
                    <TextField
                      label="Destination"
                      fullWidth
                      value={values.door_delivery_destination}
                      onChange={(e) =>
                        setFieldValue(
                          'door_delivery_destination',
                          e.target.value,
                        )
                      }
                      error={
                        touched.door_delivery_destination &&
                        Boolean(errors.door_delivery_destination)
                      }
                      helperText={
                        touched.door_delivery_destination &&
                        errors.door_delivery_destination
                      }
                    />
                    
                  )} */}
              {/* {localServiceType  === 2 && selectedModeOfDelivery?.id === 1 && (
                  <>
                    <TextField
                      label="Destination"
                      fullWidth
                      value={values.door_delivery_destination}
                      onChange={(e) =>
                        setFieldValue(
                          'door_delivery_destination',
                          e.target.value,
                        )
                      }
                      error={
                        touched.door_delivery_destination &&
                        Boolean(errors.door_delivery_destination)
                      }
                      helperText={
                        touched.door_delivery_destination &&
                        errors.door_delivery_destination
                      }
                    />

                    <Autocomplete
                      options={vehiclesOptions}
                      getOptionLabel={(option) =>
                        option?.vehicle_no && option?.vehicle_type
                          ? `${option.vehicle_no} (${option.vehicle_type})`
                          : option?.vehicle_name && option?.price
                          ? `${option.vehicle_name} (₹${option.price})`
                          : ''
                      }
                      value={values.vehicle}
                      fullWidth
                      loading={loadingVehicles}
                      onChange={(_, newValue) =>
                        setFieldValue('vehicle', newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Vehicle"
                          fullWidth
                          required
                          error={touched.vehicle && Boolean(errors.vehicle)}
                          helperText={touched.vehicle && (typeof errors.vehicle === 'string' ? errors.vehicle : errors.vehicle?.id || 'Vehicle is required')}
                        />
                      )}
                    />

                    <Autocomplete
                      options={driversOptions}
                      getOptionLabel={(option) =>
                        option?.driver_name ||
                        `${option?.first_name || ''} ${
                          option?.last_name || ''
                        }`.trim()
                      }
                      value={values.driver}
                      fullWidth
                      loading={loadingDrivers}
                      onChange={(_, newValue) =>
                        setFieldValue('driver', newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Driver"
                          fullWidth
                          required
                          error={touched.driver && Boolean(errors.driver)}
                          helperText={touched.driver && (typeof errors.driver === 'string' ? errors.driver : errors.driver?.id || 'Driver is required')}
                        />
                      )}
                    />
                  </>
                )} */}

              {localServiceType === 2 && selectedModeOfDelivery?.id === 2 && (
                <Autocomplete
                  options={godownDestinationList}
                  fullWidth
                  getOptionLabel={(option) => option?.destination_name || ''}
                  value={
                    godownDestinationList.find(
                      (d) => d.id === values.godown_delivery_destination_id,
                    ) || null
                  }
                  onChange={(_, newValue) => {
                    setFieldValue(
                      'godown_delivery_destination_id',
                      newValue?.id || null,
                    )
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Godown Destination"
                      fullWidth
                      required
                      error={
                        touched.godown_delivery_destination_id &&
                        Boolean(errors.godown_delivery_destination_id)
                      }
                      helperText={
                        touched.godown_delivery_destination_id &&
                        errors.godown_delivery_destination_id
                      }
                    />
                  )}
                />
              )}

              {/* </> */}
              {/* )} */}
              <Autocomplete
                fullWidth
                options={paymentStatusOptions}
                getOptionLabel={(option) => option.name}
                value={values.payment_status ? paymentStatusOptions.find(opt => opt.id === values.payment_status) : null}
                onChange={(_, newValue) => {
                  setFieldValue('payment_status', newValue?.id || null);
                  setSelectedPaymentStatus(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment Status"
                    fullWidth
                    required
                    error={Boolean(touched.payment_status && errors.payment_status)}
                    helperText={touched.payment_status && errors.payment_status}
                  />
                )}
              />
            </Stack>

            {isOutstationService(localServiceType) && (
              <>

                <Scrollbar>
                  <TableContainer sx={{ minWidth: 720, whiteSpace: 'nowrap' }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ minWidth: 40 }}>#</TableCell>
                          <TableCell sx={{ minWidth: 160 }} align="center">
                            Type
                          </TableCell>
                          <TableCell sx={{ minWidth: 180 }} align="center">
                            Item
                          </TableCell>
                          <TableCell sx={{ minWidth: 100 }} align="center">
                            Qty
                          </TableCell>
                          <TableCell sx={{ minWidth: 140 }} align="center">
                            Weight
                          </TableCell>
                          <TableCell sx={{ minWidth: 140 }} align="center">
                            Chrg. Wt
                          </TableCell>
                          {/* {user?.user_type === 1 && (
                        <TableCell sx={{ minWidth: 140 }} align="center">
                          Price
                        </TableCell>
                      )} */}
                          {values.items.length > 1 && (
                            <TableCell sx={{ minWidth: 80 }} align="center">
                              Actions
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {values.items.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ minWidth: 40 }}>{index + 1}</TableCell>

                            <TableCell sx={{ minWidth: 160 }}>
                              <Autocomplete
                                options={productTypes}
                                fullWidth
                                size="small"
                                getOptionLabel={(option) => option.name || ''}
                                value={values.items[index]?.product_type || null}
                                onChange={(_, newValue) => {
                                  setFieldValue(
                                    `items[${index}].product_type`,
                                    newValue,
                                  )
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Type"
                                    size="small"
                                    error={Boolean(
                                      touched.items?.[index]?.product_type &&
                                      errors.items?.[index]?.product_type,
                                    )}
                                    helperText={
                                      touched.items?.[index]?.product_type &&
                                      errors.items?.[index]?.product_type
                                    }
                                  />
                                )}
                              />
                            </TableCell>

                            <TableCell sx={{ minWidth: 180 }}>
                              <Autocomplete
                                options={contentTypes}
                                fullWidth
                                size="small"
                                getOptionLabel={(option) => option.name || ''}
                                value={values.items[index]?.item || null}
                                onChange={(_, newValue) => {
                                  setFieldValue(`items[${index}].item`, newValue)
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Item"
                                    size="small"
                                    error={Boolean(
                                      touched.items?.[index]?.item &&
                                      errors.items?.[index]?.item,
                                    )}
                                    helperText={
                                      touched.items?.[index]?.item &&
                                      errors.items?.[index]?.item
                                    }
                                  />
                                )}
                              />
                              {/* <TextField
                            fullWidth
                            size="small"
                            label="Item"
                            value={item.item}
                            onChange={(e) => setFieldValue(`items[${index}].item`, e.target.value)}
                            error={Boolean(touched.items?.[index]?.item && errors.items?.[index]?.item)}
                            helperText={touched.items?.[index]?.item && errors.items?.[index]?.item}
                          /> */}
                            </TableCell>

                            <TableCell sx={{ minWidth: 140 }}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Qty"
                                value={item.qty}
                                onChange={(e) =>
                                  setFieldValue(
                                    `items[${index}].qty`,
                                    e.target.value,
                                  )
                                }
                                error={Boolean(
                                  touched.items?.[index]?.qty &&
                                  errors.items?.[index]?.qty,
                                )}
                                helperText={
                                  touched.items?.[index]?.qty &&
                                  errors.items?.[index]?.qty
                                }
                              />
                            </TableCell>

                            <TableCell sx={{ minWidth: 140 }}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Weight"
                                value={item.weight}
                                type="number"
                                inputProps={{ min: 0 }}
                                onChange={(e) => {
                                  const value = e.target.value
                                  // Prevent negative or non-numeric input
                                  if (parseFloat(value) >= 0 || value === '') {
                                    setFieldValue(`items[${index}].weight`, value)
                                  }
                                }}
                                error={Boolean(
                                  touched.items?.[index]?.weight &&
                                  errors.items?.[index]?.weight,
                                )}
                                helperText={
                                  touched.items?.[index]?.weight &&
                                  errors.items?.[index]?.weight
                                }
                              />
                            </TableCell>

                            <TableCell sx={{ minWidth: 140 }}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Chrg. Wt"
                                value={item.charge_weight || ''}
                                type="number"
                                inputProps={{ min: 0 }}
                                onChange={(e) => {
                                  const value = e.target.value
                                  // Prevent negative or non-numeric input
                                  if (parseFloat(value) >= 0 || value === '') {
                                    setFieldValue(`items[${index}].charge_weight`, value)
                                  }
                                }}
                                error={Boolean(
                                  touched.items?.[index]?.charge_weight &&
                                  errors.items?.[index]?.charge_weight,
                                )}
                                helperText={
                                  touched.items?.[index]?.charge_weight &&
                                  errors.items?.[index]?.charge_weight
                                }
                              />
                            </TableCell>

                            {/* <TableCell sx={{ minWidth: 140 }}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Price"
                            value={item.price}
                            InputProps={{ readOnly: true }}
                            error={Boolean(
                              touched.items?.[index]?.price &&
                                errors.items?.[index]?.price,
                            )}
                            helperText={
                              touched.items?.[index]?.price &&
                              errors.items?.[index]?.price
                            }
                          />
                        </TableCell> */}
                            {/* {user?.user_type === 1 && (
                          <TableCell sx={{ minWidth: 140 }}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Price"
                              value={item.price}
                              onChange={(e) =>
                                setFieldValue(
                                  `items[${index}].price`,
                                  e.target.value,
                                )
                              }
                              error={Boolean(
                                touched.items?.[index]?.price &&
                                  errors.items?.[index]?.price,
                              )}
                              helperText={
                                touched.items?.[index]?.price &&
                                errors.items?.[index]?.price
                              }
                            />
                          </TableCell>
                        )} */}
                            {values.items.length > 1 && (
                              <TableCell align="center">
                                <IconButton
                                  onClick={() => {
                                    const updated = [...values.items]
                                    updated.splice(index, 1)
                                    setFieldValue('items', updated)
                                  }}
                                >
                                  <Stack
                                    color="error.main"
                                    className="mi--delete"
                                  />
                                </IconButton>
                              </TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    startIcon={<Stack className="lets-icons--add-duotone" />}
                    sx={{ borderRadius: 1, boxShadow: 'none' }}
                    color="primary"
                    size="small"
                    onClick={() => {
                      setFieldValue('items', [
                        ...values.items,
                        {
                          product_type: null,
                          item: '',
                          qty: '',
                          weight: '',
                          // price: '',
                        },
                      ])
                    }}
                  >
                    Add Another Item
                  </Button>
                </Box>
              </>
            )}

            {(user?.user_type === 1 || user?.user_type === 5) && (
              <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                <TextField
                  fullWidth
                  label="Invoice No"
                  required={isOutstationService(localServiceType)}
                  value={values.invoice_no}
                  onChange={(e) => setFieldValue('invoice_no', e.target.value)}
                  InputProps={{ readOnly: isLocalStyleService(localServiceType) }}
                  error={Boolean(touched.invoice_no && errors.invoice_no)}
                  helperText={touched.invoice_no && errors.invoice_no}
                />

                {isOutstationService(localServiceType) && (
                  <TextField
                    fullWidth
                    label="Invoice Value"
                    type="number"
                    required={isOutstationService(localServiceType)}
                    value={values.invoice_value}
                    onChange={(e) =>
                      setFieldValue('invoice_value', e.target.value)
                    }
                    error={Boolean(touched.invoice_value && errors.invoice_value)}
                    helperText={touched.invoice_value && errors.invoice_value}
                  />
                )}

              </Stack>
            )}

            {(user?.user_type === 1 || user?.user_type === 5 || user?.user_type === 8) && (
              <Scrollbar>
                <Stack direction="column" gap={2}>
                  <Typography variant="h6">Transport Charges</Typography>
                  <Stack
                    direction="row"
                    gap={3}
                    sx={{ minWidth: 720, whiteSpace: 'nowrap' }}
                  >
                    {isOutstationService(localServiceType) && (
                      <>

                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Freight</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('freight')}
                            onChange={(e) => {
                              const freightValue = parseFloat(e.target.value) || 0;
                              const taxValue = freightValue * 0.02;
                              setFieldValue('freight', e.target.value);
                              setFieldValue('tax', taxValue.toFixed(2));
                            }}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            error={Boolean(touched.freight && errors.freight)}
                            helperText={touched.freight && errors.freight}
                          />
                        </Stack>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Surcharge</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('surcharge')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            error={Boolean(touched.surcharge && errors.surcharge)}
                            helperText={touched.surcharge && errors.surcharge}
                          />
                        </Stack>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Stationary</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('stationary')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            error={Boolean(touched.stationary && errors.stationary)}
                            helperText={touched.stationary && errors.stationary}
                          />
                        </Stack>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Handling</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('handling')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            error={Boolean(touched.handling && errors.handling)}
                            helperText={touched.handling && errors.handling}
                          />
                        </Stack>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Demurrage</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('demurrage')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            error={Boolean(touched.demurrage && errors.demurrage)}
                            helperText={touched.demurrage && errors.demurrage}
                          />
                        </Stack>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Door Collect</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('door_collect')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            error={Boolean(
                              touched.door_collect && errors.door_collect,
                            )}
                            helperText={touched.door_collect && errors.door_collect}
                          />
                        </Stack>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Door Delivery</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('door_delivery')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            error={Boolean(
                              touched.door_delivery && errors.door_delivery,
                            )}
                            helperText={
                              touched.door_delivery && errors.door_delivery
                            }
                          />
                        </Stack>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Insurance</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('insurance')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            error={Boolean(touched.insurance && errors.insurance)}
                            helperText={touched.insurance && errors.insurance}
                          />
                        </Stack>
                      </>
                    )}
                    <Stack direction="column" gap={1}>
                      <Typography variant="subtitle2">Total Charge</Typography>
                      <TextField
                        sx={{ minWidth: 80 }}
                        size="small"
                        type="number"
                        required
                        {...getFieldProps('total_charge')}
                        onKeyDown={(e) => {
                          if (['e', 'E', '+', '-'].includes(e.key)) {
                            e.preventDefault()
                          }
                        }}
                        // InputProps={{ readOnly: true }}
                        error={Boolean(
                          touched.total_charge && errors.total_charge,
                        )}
                        helperText={touched.total_charge && errors.total_charge}
                      />
                    </Stack>
                    {isOutstationService(localServiceType) && (
                      <>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Subtotal</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            {...getFieldProps('subtotal')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault()
                              }
                            }}
                            // InputProps={{ readOnly: true }}
                            error={Boolean(touched.subtotal && errors.subtotal)}
                            helperText={touched.subtotal && errors.subtotal}
                          />
                        </Stack>

                        <Stack direction="column" gap={1}>
                          <Tooltip
                            placement="top"
                            title="Auto-calculated from freight, Freight * 0.02"
                          >
                            <Typography variant="subtitle2">Tax</Typography>
                          </Tooltip>

                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('tax')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            // InputProps={{ readOnly: true }}
                            error={Boolean(touched.tax && errors.tax)}
                            helperText={touched.tax && errors.tax}
                          />
                        </Stack>
                        <Stack direction="column" gap={1}>
                          <Typography variant="subtitle2">Total</Typography>
                          <TextField
                            sx={{ minWidth: 80 }}
                            size="small"
                            type="number"
                            required
                            {...getFieldProps('total')}
                            onKeyDown={(e) => {
                              if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            // InputProps={{ readOnly: true }}
                            error={Boolean(touched.total && errors.total)}
                            helperText={touched.total && errors.total}
                          />
                        </Stack>
                      </>
                    )}
                  </Stack>
                </Stack>
              </Scrollbar>
            )}
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={2}
              alignContent={'center'}
            >
              <TextField
                fullWidth
                label="Comments"
                {...getFieldProps('comments')}
                error={Boolean(touched.comments && errors.comments)}
                helperText={touched.comments && errors.comments}
              />
            </Stack>
            {/* {user?.user_type != 2 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.excludeTax}
                    onChange={(e) =>
                      setFieldValue('excludeTax', e.target.checked)
                    }
                    color="primary"
                  />
                }
                label="Exclude Tax"
              />
            )} */}
            <Grid item xs={12}>
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <LoadingButton
                  sx={{
                    boxShadow: 'none',
                    bgcolor: isApprovalMode ? 'secondary.main' : 'primary.main',
                    '&:hover': {
                      bgcolor: isApprovalMode ? 'secondary.dark' : 'primary.dark',
                    },
                  }}
                  startIcon={
                    <Stack
                      className={
                        isApprovalMode
                          ? 'mdi--package-variant-closed-check'
                          : isEdit
                            ? 'ic--twotone-edit'
                            : 'lets-icons--add-duotone'
                      }
                      sx={{ width: 24, height: 24 }}
                    />
                  }
                  type="submit"
                  variant="contained"
                  loading={isSubmitting || loadingBookingId}
                  disabled={loadingBookingId}
                >
                  {isApprovalMode
                    ? 'Submit & Approve'
                    : isEdit
                      ? 'Update Booking'
                      : 'Add Booking'}
                </LoadingButton>
              </Stack>
            </Grid>
            <Dialog
              maxWidth={'xl'}
              open={openAddSenderDialog}
              onClose={() => setOpenAddSenderDialog(false)}
            >
              <DialogTitle>Add Sender Form</DialogTitle>
              <MayuraCustomerAddEditForm
                isEdit={false}
                currentUser={null}
                onClose={() => setOpenAddSenderDialog(false)}
                onSuccess={handleSenderAdded}
                submitLabel="Add Sender"
              />
            </Dialog>
            <Dialog
              maxWidth={'xl'}
              open={openAddReceiverDialog}
              onClose={() => setOpenAddReceiverDialog(false)}
            >
              <DialogTitle>Add Receiver Form</DialogTitle>
              <MayuraReceiverAddEditForm
                isEdit={false}
                currentUser={null}
                onClose={() => setOpenAddReceiverDialog(false)}
                onSuccess={handleReceiverAdded}
              />
            </Dialog>
          </Stack>
        </Card>
        )}
      </Form>
      {/* Local Booking Confirmation Dialog */}
      <Dialog
        open={openLocalConfirm}
        disableEscapeKeyDown={isConfirmLoading || isPassengerDirectConfirm}
        onClose={(event, reason) => {
          if (isConfirmLoading) return;
          // Passenger website: keep the summary open until Confirm or Cancel.
          if (
            isPassengerDirectConfirm &&
            (reason === 'backdropClick' || reason === 'escapeKeyDown')
          ) {
            return;
          }
          if (isPassengerMobileReview) {
            handlePassengerReviewBack();
          } else {
            setOpenLocalConfirm(false);
            if (isPassengerDirectConfirm) {
              passengerDirectConfirmStartedRef.current = false;
              onClose();
            }
          }
        }}
        maxWidth="sm"
        fullWidth
        fullScreen={isPassengerMobileReview}
      >
        {isPassengerMobileReview ? (
          <Box sx={{ p: 2, pb: 4, bgcolor: '#F8FAFC', minHeight: '100vh', color: 'text.primary', overflowY: 'auto' }}>
            {/* Top Bar / Header */}
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2.5 }}>
              <IconButton
                onClick={handlePassengerReviewBack}
                disabled={isConfirmLoading}
                sx={{
                  p: 1,
                  bgcolor: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  color: 'text.primary',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                  '&:hover': { bgcolor: '#F3F4F6' },
                }}
              >
                <ArrowBack />
              </IconButton>
              <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', fontSize: '1.2rem' }}>
                Review Booking
              </Typography>
            </Stack>

            <Stack spacing={2} sx={{ maxWidth: 600, mx: 'auto' }}>
              {/* 1. Vehicle Summary Card */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 2.5,
                  bgcolor: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                }}
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    component="img"
                    src={pendingPayload?.vehicle?.vehicle_image || ThreeWheelerImg}
                    alt={pendingPayload?.vehicle?.vehicle_name || 'Passenger Vehicle'}
                    sx={{ width: 64, height: 50, objectFit: 'contain', flexShrink: 0 }}
                  />
                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: 'text.primary', fontSize: '1rem' }} noWrap>
                      {pendingPayload?.vehicle?.vehicle_name || 'Passenger Ride'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.2, fontWeight: 600 }}>
                      {pendingPayload?.vehicle?.capacity ? `${pendingPayload.vehicle.capacity} People` : 'Passenger'}
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', fontSize: '1.15rem' }}>
                      ₹{pendingPayload?.total}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.72rem', fontWeight: 600 }}>
                      Total
                    </Typography>
                  </Box>
                </Stack>
              </Paper>

              {/* 2. One-way trip Section (Timeline) */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 2.5,
                  bgcolor: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary', fontSize: '0.92rem', mb: 1.5 }}>
                  One-way trip
                </Typography>

                <Stack spacing={1}>
                  {/* Pickup Row */}
                  <Stack direction="row" alignItems="flex-start" spacing={1.5}>
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        bgcolor: 'success.main',
                        mt: 0.6,
                        flexShrink: 0,
                      }}
                    />
                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, fontSize: '0.7rem', display: 'block', textTransform: 'uppercase' }}>
                        Pickup
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.85rem' }}>
                        {pendingPayload?.sender?.address || pendingPayload?.sender?.city || 'N/A'}
                      </Typography>
                    </Box>
                  </Stack>

                  {/* Distance Connecting Line & Pill */}
                  <Stack direction="row" alignItems="center" spacing={1.5} sx={{ pl: '4px' }}>
                    <Box sx={{ width: 2, height: 32, bgcolor: '#E5E7EB' }} />
                    {pendingPayload?.distance && (
                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          bgcolor: 'rgba(0, 167, 111, 0.08)',
                          color: 'primary.main',
                          px: 1.2,
                          py: 0.3,
                          borderRadius: 1.5,
                          border: '1px solid rgba(0, 167, 111, 0.2)',
                          fontSize: '0.75rem',
                          fontWeight: 700,
                          ml: 1,
                        }}
                      >
                        {pendingPayload.distance} km
                      </Box>
                    )}
                  </Stack>

                  {/* Destination Row */}
                  <Stack direction="row" alignItems="flex-start" spacing={1.5}>
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: '2px',
                        bgcolor: 'error.main',
                        mt: 0.6,
                        flexShrink: 0,
                      }}
                    />
                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, fontSize: '0.7rem', display: 'block', textTransform: 'uppercase' }}>
                        Destination
                      </Typography>
                      <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.85rem' }}>
                        {typeof pendingPayload?.destination === 'string'
                          ? pendingPayload.destination
                          : (pendingPayload?.destination?.branch_name || pendingPayload?.destination?.destination_name || 'N/A')}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>
              </Paper>

              {/* 3. Passenger Section */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 2.5,
                  bgcolor: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                }}
              >
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, fontSize: '0.7rem', display: 'block', textTransform: 'uppercase', mb: 0.8 }}>
                  Passenger
                </Typography>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary', fontSize: '0.9rem' }}>
                    {pendingPayload?.passenger_name || pendingPayload?.sender?.user_name || pendingPayload?.sender?.first_name || user?.user_name || 'Passenger'}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.85rem' }}>
                    {pendingPayload?.sender_phone || pendingPayload?.sender?.phone_number || user?.phone_number || 'N/A'}
                  </Typography>
                </Stack>
              </Paper>

              {/* 5. Price Breakdown Section */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 2.5,
                  bgcolor: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.primary', fontSize: '0.92rem', mb: 1.5 }}>
                  Price breakdown
                </Typography>
                <Stack spacing={1.2}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                      Base price
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.85rem' }}>
                      ₹{pendingPayload?.vehicle?.basic_price || 0}
                    </Typography>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                      Distance
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.85rem' }}>
                      {pendingPayload?.distance || 0} km
                    </Typography>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                      Included distance
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.85rem' }}>
                      {pendingPayload?.vehicle?.minimum_km || 1} km
                    </Typography>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                      Extra rate
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '0.85rem' }}>
                      ₹{pendingPayload?.vehicle?.per_km_price || 0} / km
                    </Typography>
                  </Stack>

                  <Divider sx={{ my: 0.5, borderColor: '#E5E7EB' }} />

                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: 'text.primary', fontSize: '1rem' }}>
                      Total price
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 800, color: 'primary.main', fontSize: '1.25rem' }}>
                      ₹{pendingPayload?.total}
                    </Typography>
                  </Stack>
                </Stack>
              </Paper>

              {/* Book Ride CTA Button (Inside form content) */}
              <LoadingButton
                variant="contained"
                size="large"
                fullWidth
                onClick={handleFinalConfirm}
                loading={isConfirmLoading}
                disabled={isConfirmLoading}
                sx={{
                  mt: 1,
                  py: 1.6,
                  borderRadius: '14px',
                  fontSize: 16,
                  fontWeight: 800,
                  textTransform: 'none',
                  bgcolor: 'primary.main',
                  color: '#fff',
                  boxShadow: '0 8px 20px rgba(0, 167, 111, 0.24)',
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  },
                }}
              >
                {/* Book {pendingPayload?.vehicle?.vehicle_name || 'Ride'} — ₹{pendingPayload?.total} */}
                Confirm & Submit
              </LoadingButton>
            </Stack>
          </Box>
        ) : (
          <>
            <DialogTitle sx={{
              textAlign: 'center',
              bgcolor: 'primary.main',
              color: 'white',
              '@media print': {
                display: 'none'
              }
            }}>
              Booking Summary & Confirmation
            </DialogTitle>
            <Box sx={{ px: 3, pt: 3, pb: 1 }} id="printable-booking-summary">
              <Typography variant="h6" gutterBottom>Invoice Details</Typography>
              <TableContainer sx={{ mt: 2 }}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', width: '40%', border: 'none' }}>Booking No</TableCell>
                      <TableCell sx={{ width: '60%', border: 'none' }}>: {pendingPayload?.bookingNo}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>Invoice No</TableCell>
                      <TableCell sx={{ border: 'none' }}>: {pendingPayload?.invoice_no}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>Vehicle</TableCell>
                      <TableCell sx={{ border: 'none' }}>: {pendingPayload?.vehicle?.vehicle_name || 'N/A'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>Basic Price ({pendingPayload?.vehicle?.minimum_km || 1} km)</TableCell>
                      <TableCell sx={{ border: 'none' }}>: ₹{pendingPayload?.vehicle?.basic_price || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>Extra Price Per KM</TableCell>
                      <TableCell sx={{ border: 'none' }}>: ₹{pendingPayload?.vehicle?.per_km_price || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>Distance</TableCell>
                      <TableCell sx={{ border: 'none' }}>: {pendingPayload?.distance} km</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>
                        {isPassengerBookingEdit
                          ? 'Passenger Name'
                          : isPassengerDirectConfirm
                            ? 'Passenger'
                            : 'Sender'}
                      </TableCell>
                      <TableCell sx={{ border: 'none' }}>
                        : {pendingPayload?.passenger_name
                          || pendingPayload?.sender?.user_name
                          || pendingPayload?.sender?.first_name}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>
                        {isPassengerBookingEdit
                          ? 'Passenger Number'
                          : isPassengerDirectConfirm
                            ? 'Passenger Phone'
                            : 'Sender Phone'}
                      </TableCell>
                      <TableCell sx={{ border: 'none' }}>: {pendingPayload?.sender_phone || 'N/A'}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>
                        {isPassengerDirectConfirm ? 'Passenger Location' : 'Sender Location'}
                      </TableCell>
                      <TableCell sx={{ border: 'none' }}>: {pendingPayload?.sender?.address || pendingPayload?.sender?.city}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>Destination</TableCell>
                      <TableCell sx={{ border: 'none' }}>
                        : {typeof pendingPayload?.destination === 'string'
                          ? pendingPayload.destination
                          : (pendingPayload?.destination?.branch_name || pendingPayload?.destination?.destination_name)}
                      </TableCell>
                    </TableRow>
                    {!isPassengerDirectConfirm && !isPassengerBookingEdit && (
                      <>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>Receiver Name</TableCell>
                          <TableCell sx={{ border: 'none' }}>: {pendingPayload?.receiver_name || 'N/A'}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', border: 'none' }}>Receiver Phone</TableCell>
                          <TableCell sx={{ border: 'none' }}>: {pendingPayload?.receiver_phone || 'N/A'}</TableCell>
                        </TableRow>
                      </>
                    )}
                    <TableRow sx={{ borderTop: '2px solid #eee' }}>
                      <TableCell sx={{ fontWeight: 'bold', color: 'primary.main', fontSize: '1.2rem', border: 'none' }}>Total Charge</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', color: 'primary.main', fontSize: '1.2rem', border: 'none' }}>
                        <Tooltip title={`₹${pendingPayload?.vehicle?.basic_price || 0} + (₹${pendingPayload?.vehicle?.per_km_price || 0} * (${pendingPayload?.distance || 0} - ${pendingPayload?.vehicle?.minimum_km || 1}))`} placement="top">
                          <span>: ₹{pendingPayload?.total}</span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                px: 3,
                pb: 3,
                pt: 0,
                justifyContent: 'center',
                '@media print': {
                  display: 'none'
                }
              }}
            >
              <LoadingButton
                variant="contained"
                onClick={handleFinalConfirm}
                color="primary"
                loading={isConfirmLoading}
                disabled={isConfirmLoading}
              >
                Confirm & Submit
              </LoadingButton>
              <Button
                variant="text"
                onClick={() => {
                  setOpenLocalConfirm(false);
                  if (isPassengerDirectConfirm) {
                    passengerDirectConfirmStartedRef.current = false;
                    onClose();
                  }
                }}
                color="inherit"
                disabled={isConfirmLoading}
              >
                Cancel
              </Button>
            </Stack>
          </>
        )}
      </Dialog>

      {/* Passenger service only — loader on Confirm & Submit (no white card) */}
      {isPassengerService(pendingPayload?.service_type ?? localServiceType) && (
        <Backdrop
          open={isConfirmLoading}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
          sx={{
            zIndex: (theme) => theme.zIndex.modal + 2,
            bgcolor: 'rgba(0,0,0,0.45)',
            pointerEvents: 'auto',
          }}
        >
          <Box
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              p: 3,
            }}
          >
            <CircularProgress size={48} sx={{ color: 'primary.main', mb: 2 }} />
            <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700 }}>
              Creating booking...
            </Typography>
          </Box>
        </Backdrop>
      )}
    </FormikProvider>
  )
}
